import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    applyMaskAmountFreeDecimals,
    checkAssetsAndSubAssetsEndFundoZeroBalance,
    checkAssetsAndSubAssetsSameBalances,
    checkAssetsAndSubAssetsSameFinalQuotas,
    checkIsSameBalance,
    checkIsSameQuotas,
    formatStringToDisplay,
    getBusinessDaysInMonth,
    getFirstDayMonth,
    getInMonthRentFundInPortfolio,
    getLastDayInMonthByMonthAndYear,
    getLastDayMonth,
    getLastDayMonthAgo,
    getLastMonthYearAbleToQuotas,
    getMonthFundRentInMoney,
    getMonthsByArray,
    getTitleCod,
    isDateBeforeInit,
    portfolioClosedToDate,
    stringPtDateToMoment
} from '../../utils/utils';

import Fade from '@material-ui/core/Fade';

//Tables
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../../utils/MyTable';

//Utils
import {
    applyMaskAmount,
    formatAnbimaDateToPt,
    getMonthName,
    isDateAfterClosedMonth,
    isFileForClientOn,
    justNumbers,
    parseFloatByPtCurrency
} from '../../utils/utils';

import moment from 'moment';

//Api
import { ClientAPI } from '../../../API/client';
import { FundAPI } from '../../../API/fund';
import { TitleAPI } from '../../../API/title';
import { TransactionAPI } from '../../../API/transaction';
import { findDuplicatedPortfolioAssets, findInvalidDiaryDays } from '../../utils/portfolioAnalysisUtils';
import { SelicCdiIpcaAPI } from '../../../API/selicCdiIpca';


import Checkbox from '@material-ui/core/Checkbox';

//Grid
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField, Typography } from "@material-ui/core";

//redux
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../actions';

//Import excel
import { getJsDateFromExcel } from 'excel-date-to-js';
import XLSX from 'xlsx';
import { SheetJSFT } from '../../utils/types';

import AddIcon from '@material-ui/icons/Add';
import PublishIcon from '@material-ui/icons/Publish';

//UnoButton
import { headerSearch, tabs, unoTheme } from '../../../assets/styles/unoTheme';
import UnoButton from '../../utils/UnoButton';
import MyTextField from '../../utils/MyTextField';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DoneIcon from '@material-ui/icons/Done';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import _ from 'lodash';
import AmortizationsToCreateModal from "../../modals/AmortizationsToCreateModal";
import DataImportModal from "../../modals/DataImportModal";
import FundsPendenciesModal from "../../modals/FundsPendenciesModal";
import InconsistentFundsModal from "../../modals/InconsistentFundsModal";
import OffAssetsValidateModal from "../../modals/OffAssetsValidateModal";
import NewSpecialClientQuotaModal from "../../modals/NewSpecialClientQuotaModal";

import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';

import { doGetAccountIdByNumberAccountAndCnpjAsset } from '../../../controllers/AccountController';
import { getAssetInfos, getRentPortfolioInMonth, getSegmentKeyById, NO_INIT_QUOTA, SEGMENT_CODS_AND_IDS } from '../../../controllers/AssetsController';
import { doSaveFundClientRent, groupFundsBySegmentAndArticle, validatorFundsClientRents } from '../../../controllers/FundController';
import { checkAssetTitleDivergentBalance, doSaveTitleClientRent, GENERIC_ASSET_TITLES_TYPE, getProjectedRentMonthTitle, getProjectedReturnValue, isConsigTitle, isGenericTitle, needQuotasTitle, OUT_OF_MARKET_RENT_TITLE, verifyTitlesAmortizations } from '../../../controllers/TitleController';
import { doBulkUpdateInfosByListFunds, doBulkUpdateQuotasByListFunds } from '../../../controllers/ComdinheiroController';
import { analyzeFundsPendencies, countFundsPendenciesIssues, selectFundsToBulkQuotasUpdate } from '../../utils/fundsPendenciesUtils';
import { getAlertBalanceContent } from '../../utils/MyAlertBalance';
import { getAlertSpecialClientQuotaContent } from '../../utils/MyAlertSpecialClientQuota';

import Backdrop from '@material-ui/core/Backdrop';

import { BalancesValidationsAPI } from '../../../API/balances_validations';
import { saveLogPortfolioLaunch } from "../../../controllers/LogActionController";
import { sendLaunchPortofolioEmail } from "../../../controllers/MailController";
import { SystemValidationsController } from '../../../controllers/SystemValidationsController';
import { getRentInMoneyMonthTitle, getRentMonthTitle } from "../../../controllers/TitleController";
import InconsistentBalancesModal from '../../modals/InconsistentBalancesModal';
import InconsistentTitlesModal from '../../modals/InconsistentTitlesModal';
import DefaultScrollWithHeaderContent from '../../utils/DefaultScrollWithHeaderContent';
import MyAutoComplete from '../../utils/MyAutoComplete';
import { MyTab, MyTabs } from "../../utils/MyTabs";
import MyToggleSegregationButton from "../../utils/MyToggleSegregationButton";
import { MARKING_CURVE } from "../../utils/paramsToTitles";
import { checkUserIsRole, roles } from "../../utils/user";
import TransactionsTable from "./TransactionsTable";

const rightDivWidth = 450;

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #E6E8ED"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: "1px solid #E6E8ED",
        color: "#4A4A4A"
    }
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },

    headerSearch: headerSearch,

    iconWhite: {
        color: 'white',
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    inputsAccount: {
        width: '100%',
    },
    cellIcon: {
        padding: '0px'
    },
    alignLeft: {
        textAlign: "left",
        '& fieldset': {

            '& legend': {
                fontSize: '0.9em !important',
            }

        }

    },
    headerDetail: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'center',
        padding: theme.spacing(2),

        '& .MuiTypography-root': {
            marginBottom: '0px',
        }
    },
    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    input: {
        display: 'none',
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    optionNativeSelect: {
        padding: "10px !important"
    },
    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    tableTh: {
        fontWeight: 'bold'
    },
    cellStatusApr: {
        paddingTop: '13px',
    },
    textCenter: {
        textAlign: 'center',
    },
    textAutoComplete: {
        fontSize: '14px',
    },
    bold: {
        fontWeight: 'bold',
    },
    monthYear: {
        color: unoTheme.secondaryColor
    },

    //RightDiv
    mainRoot: {
        height: '100%',
        width: '100%',
        transition: 'all .3s ease',
    },
    rightDiv: {
        height: '100%',
        minWidth: rightDivWidth,
        width: rightDivWidth,
        background: 'white',
        transition: 'all .3s ease',
        position: 'fixed',
        right: 0,
        //paddingRight: theme.spacing(2),
        marginRight: rightDivWidth * (-1),
    },
    rightDivOpen: {
        height: '100%',
        //marginRight: rightDivWidth - 24,
        marginRight: rightDivWidth,
        borderRight: `solid 24px ${unoTheme.menuContent}`,
    },
    rightDivClose: {
        height: '100%',
        marginRight: '0px',
    },
    rightDivContentOpen: {
        marginRight: '0px',

    },
    rightDivContentClose: {
        marginRight: rightDivWidth * (-1),
    },
    leftRightDiv: {
        background: unoTheme.menuContent,
        height: '100%',
        width: '24px',
        minWidth: '24px',
    },
    mainRightDiv: {
        float: 'right',
        height: '100%',
        //width: rightDivWidth - 24,
        //minWidth: rightDivWidth - 24,        
        width: rightDivWidth,
        minWidth: rightDivWidth,
    },
    openButton: {
        transition: 'all .3s ease',
    },
    rightDivButtonOpen: {
        //opacity: 0,
        display: 'none',
        cursor: 'unset'
    },
    rightDivButtonClose: {
        //opacity: 1,
        display: 'flex',
        cursor: 'pointer',
    },
    headerRightDiv: {
        display: "flex",
        alignItems: 'center',
        padding: theme.spacing(2),

        '& .MuiTypography-root': {
            marginBottom: '0px',
        },

        '& .MuiIconButton-root': {
            padding: '8px',
        }
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },
    formRightDiv: {
        textAlign: 'left',
        padding: theme.spacing(2),
    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'black',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .totalLinePL': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'white',
                background: unoTheme.mainColor,
            },
        },

        '& .disponibilityLine': {
            '& .MuiTableCell-footer': {
                color: 'black',
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            //color: unoTheme.greenMoney,
            fontSize: '14px',
        }
    },

    tableWithFooter: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },

    footerTable: {
        color: 'white',
        margin: '0px 18px 18px 18px',
        borderRadius: '10px',
        minHeight: '32px',
        backgroundColor: unoTheme.mainColor,
        width: 'calc(100% - 48px)',
        height: '32px',
        display: 'flex',
        alignItems: 'center',

        '& .MuiTypography-root': {
            fontSize: '12px',
        },

        '& .d': {
            padding: '0px 24px 0px 16px',
        },
        '& .d1': {
            textAlign: 'left',
            width: "35%"
        },
        '& .d2': {
            width: "15%"
        },
        '& .d3': {
            width: "15%",
            textAlign: 'right',

        },
        '& .d4': {
            width: "10%"
        },
        '& .d5': {
            width: "10%"
        },
        '& .d6': {
            width: "15%"
        },
    },

    lounchedWalletLabel: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: `${unoTheme.successColor} !important`,
        '& span': {
            marginRight: '5px',
        }
    },

    tabs: tabs,

    tabsWithRight: {
        display: 'flex',
        flexDirection: 'row',
        paddingRight: theme.spacing(2),
        alignItems: 'center',

        '& .MuiToggleButtonGroup-root': {
            alignItems: 'center',

            '& .MuiToggleButton-label': {
                whiteSpace: 'nowrap'
            }
        }
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },


}));

export const useSpeedDial = () => {
    const theme = useTheme();

    const transitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };

    const useStyles = makeStyles(() => ({
        speedDial: {
            position: 'absolute',
            bottom: unoTheme.bottomFab,
            right: theme.spacing(4),
            display: 'flex',
            alignItems: 'baseline',
            flexDirection: 'column',

            '& .MuiFab-primary': {
                backgroundColor: unoTheme.mainColor,
                '&:hover': {
                    background: unoTheme.hoverMainButtonColor,
                }
            },

            '& .MuiSpeedDialAction-staticTooltipLabel': {
                padding: '4px 8px',
                whiteSpace: 'nowrap',
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: '14px'
            }

        },

        speedDial2: {
            position: 'absolute',
            right: theme.spacing(4),
            display: 'flex',
            alignItems: 'baseline',
            flexDirection: 'column',

            '& .MuiFab-primary': {
                backgroundColor: unoTheme.mainColor,
                '&:hover': {
                    background: unoTheme.hoverMainButtonColor,
                }
            },

            '& .MuiSpeedDialAction-staticTooltipLabel': {
                padding: '4px 8px',
                whiteSpace: 'nowrap',
                color: 'rgba(0, 0, 0, 0.87)',
                fontSize: '14px'
            }

        },
    }))

    return {
        transitionDuration,
        useStyles
    }
}

export default function BalancesCollectScreen(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [innerLoad, setInnerLoad] = useState({ emptyMessage: "", loadMessage: "Carregando informações...", size: "small" });

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)
    const rightContent = useSelector(state => state.rightContent)
    const [clientOnScreen, setClientOnScreen] = useState(undefined);

    const [clientAccounts, setClientAccounts] = React.useState([]);
    const [transactions, setTransactions] = React.useState(undefined);
    const [totalAmountTransactions, setTotalAmountTransactions] = React.useState(undefined);
    const [totalAmountTransactionsApplications, setTotalAmountTransactionsApplications] = React.useState(undefined);
    const [totalAmountTransactionsRescues, setTotalAmountTransactionsRescues] = React.useState(undefined);

    const [tabValue, setTabValue] = React.useState(0);
    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);

    };

    //Import Excel
    const inputFile = useRef(null);
    const [file, setFile] = useState(undefined);
    const [data, setData] = useState(undefined);
    const [dataListFormatted, setDataListFormatted] = useState(undefined);
    const [dataToInsert, setDataToInsert] = useState(undefined);
    //dataToOffAssetsModal
    const [dataOffAssets, setDataOffAssets] = useState(undefined);

    const [totalResultAmount, setTotalResultAmount] = useState(0);
    const [totalBeforeAmount, setTotalBeforeAmount] = useState(0);

    const [totalDisponibilityInAccounts, setTotalDisponibilityInAccounts] = useState({
        now: 0,
        before: 0
    });

    const [invalidQuotas, setInvalidQuotas] = useState(null);

    //Divergência entre o calendário do fundo modelo e os dias úteis (aviso no modal de pendências)
    const [quotasModelDivergence, setQuotasModelDivergence] = useState(null);

    const [showImportModal, setShowImportModal] = useState(false);
    const [fundsToInconsistentFundsModal, setFundsToInconsistentFundsModal] = useState([]);
    const [showInconsistentFundsModal, setShowInconsistentFundsModal] = useState(false);
    //OffAssetsModal
    const [showOffAssetsValidateModal, setShowOffAssetsValidateModal] = useState(false);
    //AmortizationsModal
    const [showAmortizationToCreateModal, setShowAmortizationToCreateModal] = useState(false);
    const [amortizationsToCreate, setAmortizationsToCreate] = useState(null);

    //To new transaction
    //Lançar carteira
    const [allFunds, setAllFunds] = useState(undefined)
    const [clientFunds, setClientFunds] = useState(undefined)
    const [clientTitles, setClientTitles] = useState(undefined)
    const [clientAssets, setClientAssets] = useState(undefined)
    const [clientTitleAssets, setClientTitleAssets] = useState(undefined)
    const [clientOperations, setClientOperations] = useState(undefined)
    const [assetsFormatted, setAssetsFormatted] = useState(undefined)
    //Ativos com saldo zerados
    const [offAssets, setOffAssets] = useState(undefined)
    const [fullDiaryPl, setFullDiaryPl] = useState(undefined)
    const [mapFullDiarySegregation, setMapFullDiarySegregation] = useState(undefined)
    const [mapFullDiarySegment, setMapFullDiarySegment] = useState(undefined)
    const [initPortfolioQuota, setInitPortfolioQuota] = useState(undefined)
    const [initPortfolioQuotaBySegregation, setInitPortfolioQuotaBySegregation] = useState(undefined)
    const [initPortfolioQuotaBySegment, setInitPortfolioQuotaBySegment] = useState(undefined)
    const [rentPortfolioInMonth, setRentPortfolioInMonth] = useState(undefined)
    const [rentPortfolioInMonthMoney, setRentPortfolioInMonthMoney] = useState(undefined)

    //Checando se o saldo de algum título está muito divergente em valores de PU
    const [enableDivergentTitles, setEnableDivergentTitles] = useState(false);
    const [dataToInconsistentTitlesModal, setDataToInconsistentTitlesModal] = useState();

    const [returnColumnType, setReturnColumnType] = useState('money')

    const [checkedJustToConciliations, setCheckedJustToConciliations] = useState(false)

    const [showConciliationModal, setShowConciliationModal] = useState(false);
    const [pendingLaunchArgs, setPendingLaunchArgs] = useState(undefined);
    const [conciliationLoading, setConciliationLoading] = useState(false);
    const [specialQuotaModalRow, setSpecialQuotaModalRow] = useState(null);

    const [inconsistentBalancesValidations, setInconsistentBalancesValidations] = useState([])
    const [showInconsistentBalancesValidationsModal, setShowInconsistentBalancesValidationsModal] = useState(false);

    //Pendências de cotas e dados cadastrais que travam o lançamento mensal
    const [showFundsPendenciesModal, setShowFundsPendenciesModal] = useState(false);
    const [fundsPendenciesProgress, setFundsPendenciesProgress] = useState({ running: false });
    const [fundsPendenciesResult, setFundsPendenciesResult] = useState(null);

    //Progresso/resultado da atualização disparada de dentro do InconsistentFundsModal (cotas do
    //mês anterior). Estado próprio para o resultado de um modal não aparecer no outro.
    const [inconsistentFundsProgress, setInconsistentFundsProgress] = useState({ running: false });
    const [inconsistentFundsResult, setInconsistentFundsResult] = useState(null);

    const fundsPendencies = useMemo(() => analyzeFundsPendencies(assetsFormatted, quotasModelDivergence),
        [assetsFormatted, quotasModelDivergence]);
    const fundsPendenciesCount = useMemo(() => countFundsPendenciesIssues(fundsPendencies),
        [fundsPendencies]);

    const endDayMonthDetail = useMemo(() => {
        if (clientOn?.client?.selectedMonth && clientOn?.client?.selectedYear) {

            return getLastDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear)
        }
        return null;
    }, [clientOn?.client?.selectedMonth, clientOn?.client?.selectedYear])

    const firstDayMonthDetail = useMemo(() => {
        if (clientOn?.client?.selectedMonth && clientOn?.client?.selectedYear) {

            return getFirstDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear, true)
        }
        return null;
    }, [clientOn?.client?.selectedMonth, clientOn?.client?.selectedYear])

    const initSizeTable = 20;
    const [currentSizeTable, setCurrentSizeTable] = useState(initSizeTable);
    const handleChangeCheckBoxJustConciliations = (event) => {
        setCheckedJustToConciliations(event.target.checked);
    };

    function changeReturnColumnType() {
        if (returnColumnType == 'money') {
            setReturnColumnType('percent');
        } else {
            setReturnColumnType('money');
        }
    }

    const { transitionDuration, useStyles: speedDialUseStyles } = useSpeedDial();
    const speedDialClasses = speedDialUseStyles();

    //Movs tab
    const [fundInMovs, setFundInMovs] = useState();
    const [allFundsInMovs, setAllFundsInMovs] = useState([]);

    //Índices mês vigente
    const [showSelicCdiIpcaModal, setShowSelicCdiIpcaModal] = useState(false);
    const [showSelicCdiIpcaWarning, setShowSelicCdiIpcaWarning] = useState(false);
    const [selicCdiIpcaForm, setSelicCdiIpcaForm] = useState({ selic: '0,00', ipca: '0,00', cdi: '0,00' });
    const [selicCdiIpcaSaving, setSelicCdiIpcaSaving] = useState(false);

    const isClientAbleToCurrentMonth = useMemo(() => {

        if (!clientOn?.client?.is_able_transactions_current_month
            || !clientOn?.client?.selectedMonth
            || !clientOn?.client?.selectedYear) {
            return false
        }
        const today = new Date();
        const isCurrentMonth = clientOn.client.selectedMonth === (today.getMonth() + 1) && clientOn.client.selectedYear === today.getFullYear();
        return clientOn?.client?.is_able_transactions_current_month && isCurrentMonth;
    }, [
        clientOn?.client?.is_able_transactions_current_month,
        clientOn?.client?.selectedMonth,
        clientOn?.client?.selectedYear]);

    async function getDataToCreateTransaction() {

        const response1 = await FundAPI.getAllClientAssets(clientOn.client.id);
        if (response1.success) {

            //setListClientAssets(response1.body.rows);
            setClientAssets(response1.body.rows);
            //fillClientAssets(response1.body.rows);

            const responseAllFunds = await FundAPI.getAllFunds();

            if (responseAllFunds.success) {
                setAllFunds(responseAllFunds.body.rows)
                //fillAllFunds(responseAllFunds.body.rows)
            }
        } else {
            console.log("error: ", response1.error)
        }

        const responseClientTitleAssets = await TitleAPI.getClientAssetsTitles(null, clientOn.client.id, null);
        if (responseClientTitleAssets.success) {

            setClientTitleAssets(responseClientTitleAssets.body.rows);

        } else {
            console.log("error: ", response1.error)
        }

        const promises = [];
        promises.push(new Promise(async (resolve, reject) => {
            const responseFunds = await FundAPI.getAllClientFunds(clientOn.client.id);

            if (responseFunds.success) {
                resolve(responseFunds);
            } else {
                resolve(false);
            }

        }))
        promises.push(new Promise(async (resolve, reject) => {
            const responseTitles = await TitleAPI.getAllClientTitles(clientOn.client.id);

            if (responseTitles.success) {
                resolve(responseTitles);
            } else {
                resolve(false);
            }

        }))

        const responseFundsAndTitlesPromises = await Promise.all(promises);

        //const responseFunds = await getAllClientFunds(clientOn.client.id);
        if (responseFundsAndTitlesPromises[0]) {

            setClientFunds(responseFundsAndTitlesPromises[0].body.rows)

        } else {
            console.log("error: ", responseFundsAndTitlesPromises.error)
        }
        if (responseFundsAndTitlesPromises[1]) {

            setClientTitles(responseFundsAndTitlesPromises[1].body.rows)

        } else {
            console.log("error: ", responseFundsAndTitlesPromises.error)
        }

        const response2 = await TransactionAPI.getOperations();
        if (response2.success) {
            //setOperations(response2.body.rows)
            setClientOperations(response2.body.rows)
            //fillClientOperations(response2.body.rows)
        } else {
            console.log("error: ", response2.error)
        }

    }

    function resetImportVariables() {

        console.log("Reset")
        setFile(undefined);
        setData(undefined);
        setDataListFormatted(undefined);

    }

    function handleChangeFile(e) {

        console.log("Change file")
        const files = e.target.files;
        if (files && files[0]) {
            setFile(files[0])
        }

        e.target.value = null;

    };

    function handleFile() {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws);

            console.log("FILE CONVERTIDO");

            /* Update state */
            //setData([])
            //console.log("DATA: ", data);
            setData(data);
            setFile(undefined);

        };

        if (rABS) {
            //reader.readAsBinaryString(this.state.file);
            reader.readAsBinaryString(file);
        } else {
            //reader.readAsArrayBuffer(this.state.file);
            reader.readAsArrayBuffer(file);
        };
    }

    function checkIsClientAssetByCnpjAndAccount(listLocalClientAssets, cnpj, accountId) {

        // console.log("CNPJ: ", cnpj)
        // console.log("ACCOUNT: ", accountId)
        // console.log("TO COMPARE: ", listLocalClientAssets);
        let assets = listLocalClientAssets.filter(el => el.cnpj == cnpj && el.account_id == accountId)
        if (assets && assets.length == 1) {
            //console.log("ASSET JA EXISTENTE OK!")
            return assets[0].id;
        } else {
            return null;
        }
    }

    function verifyColumnsExcel(transactionLoop) {

        console.log("TESTE DE COLUNAS: ", transactionLoop);
        let invalidColumns = [];
        if (!transactionLoop['CC']) {
            invalidColumns.push('CC');
        }
        if (!transactionLoop['CNPJ']) {
            invalidColumns.push('CNPJ');
        }
        if (!transactionLoop['DATA']) {
            invalidColumns.push('DATA');
        }
        if (!transactionLoop['TIPO']) {
            invalidColumns.push('TIPO');
        }
        if (!transactionLoop['VALOR']) {
            invalidColumns.push('VALOR');
        }
        //Removido devido o caso em que existem resgates automáticos
        //A quantidade de cotas não é informada
        //Caso encontrado no cliente João Pessoa

        // if (!transactionLoop['QUANTIDADE']) {
        //     invalidColumns.push('QUANTIDADE');
        // }

        return invalidColumns;
    }

    function verifyTransactionAfterPorfolioClosed(monthClosed, transactionDate) {

        //Verifica-se se a o mês da data da transação é menor ou igual ao mês de carteira fechada
        //Caso seja deve-se retornar false, não inserindo na lista a ser inserido no banco
        //Esse método serve para evitar duplicações e alterações de carteiras já fechadas e validadas

        //No caso da carteira ainda não possuir nenhum mÊs fechado
        if (monthClosed == null) {
            return true;
        }

        if (parseInt(transactionDate.split("/")[1]) <= monthClosed) {
            return false;
        } else {
            return true;
        }

    }

    //Faz a verificação da data formatada da linha da tabela do excel
    function verifyingDate(dateToVerify, monthsToInsert, yearsToInsert, initYear, initMonth, invalidMonths) {
        //Guardando o mês pra saber se é uma planilha anual ou mensal
        let testMonth = dateToVerify.substring(3, 5);
        //Teste para saber se existe algum erro na data de transação,
        //algum registro apontando pra alguma data de anos diferentes
        let testYear = dateToVerify.substring(6);

        //Verificando se existem movimeentações para antes do início da carteira                    
        if (initYear == testYear && parseInt(testMonth) <= initMonth) {

            if (!invalidMonths.includes(parseInt(testMonth))) {
                invalidMonths.push(parseInt(testMonth));
            }

        }

        if (!monthsToInsert.includes(testMonth)) {

            monthsToInsert.push(testMonth);

        }

        console.log("YEAR TEST: ", testYear)
        if (!yearsToInsert.includes(testYear)) {
            yearsToInsert.push(testYear)
        }
    }

    async function doPreInserts(transactions, invalidColumns, invalidDates) {

        console.log("DO PRE INSERTS")

        let initYear = moment.utc(clientOn.client.portfolio_init).format('YYYY');
        let initMonth = parseInt(moment.utc(clientOn.client.portfolio_init).format('MM'));
        //Obtendo mês da carteira fechada para fazer validação de segurança impedindo que sejam importadas movimentações
        //de meses que já foram fechados e validados
        //Ex clientOn.client.portfolio_closed: 8/2021
        let monthClosed = clientOn.client.portfolio_closed == null ? null : parseInt(clientOn.client.portfolio_closed.split('/')[0]);
        let yearClosed = clientOn.client.portfolio_closed == null ? null : parseInt(clientOn.client.portfolio_closed.split('/')[1]);
        const portfolioClosed = clientOn.client.portfolio_closed;

        let listLocalClientAssets = clientAssets ? clientAssets : [];
        let invalidsAccounts = [];
        let accountsWhite = 0;
        let invalidsFunds = [];
        let invalidMonths = [];
        let invalidNoCnpjs = 0; //linhas sem informação de cnpj

        let assetsToCreate = [];

        let mapFunds = [];

        let transactionToInsert = [];

        //Utilizado para verificar a validade da planilha, com movimentações apenas do mesmo ano
        let yearsToInsert = [];

        //Se houver apenas 1 mês inserido na lista indica que a planilha é uma planilha mensal
        let monthsToInsert = [];

        //Verificar inconsistência na sequência, caso hajam criações de ativos de mês anterior eles devem vir todos no topo da lista       

        for (let i = 0; i < transactions.length; i++) {

            let transactionLoop = transactions[i];

            //Normalizando CNPJ, retirando possíveis espaços
            if (transactionLoop['CNPJ'] != null) {

                transactionLoop['CNPJ'] = transactionLoop['CNPJ'].toString().trim();

            } else {

                invalidNoCnpjs++;

            }


            //Realizar a verificação das colunas da planilha
            if (i === 0) {

                //Caso retorne false uma ou mais colunas necessárias não foram informadas
                invalidColumns = verifyColumnsExcel(transactionLoop);

            }

            // let accountLoop = getAccountIdByAccountNumber(justNumbers(transactionLoop['CC']));
            //console.log("Account: ", transactionLoop['CC']);

            if (transactionLoop['CC']) {

                transactionLoop['CC'] = parseInt(justNumbers(transactionLoop['CC']))
                transactionLoop['CC'] = transactionLoop['CC'].toString().trim()
                //transactionLoop.account_id = getAccountIdByAccountNumber(transactionLoop['CC']);
                transactionLoop.account_id = await getAccountIdByAccountNumberAndFundCnpj(transactionLoop['CC'], transactionLoop['CNPJ']);

            } else {

                transactionLoop.account_id = 'NOT_FOUND';
                accountsWhite++;

            }
            if (transactionLoop.account_id == 'NOT_FOUND') {

                if (transactionLoop['CC']) {
                    if (!invalidsAccounts.includes(justNumbers(transactionLoop['CC']))) {
                        invalidsAccounts.push(justNumbers(transactionLoop['CC']));
                    }
                }

            } else {

                let fundId = undefined;

                if (mapFunds[transactionLoop['CNPJ'] + "=" + transactionLoop['CC']]) { //Fundo já mapeado

                    fundId = mapFunds[transactionLoop['CNPJ'] + "=" + transactionLoop['CC']];
                    //let assetId = checkIsClientAssetByCnpjAndAccount(listLocalClientAssets, transactionLoop['CNPJ'], transactionLoop.account_id)
                    const transactionFormatted = {

                        //asset_id: assetId,
                        account_id: transactionLoop.account_id,
                        operation_id: transactionLoop['TIPO'],
                        amount: transactionLoop['VALOR'],
                        description: transactionLoop['DESCRICAO'] ? transactionLoop['DESCRICAO'].substring(0, 1000) : "",
                        cnpj: transactionLoop['CNPJ'],
                        transaction_date: transactionLoop['dataFormatada']
                    };

                    //console.log("Transaction formatted: ", transactionFormatted);

                    verifyingDate(transactionLoop['dataFormatada'],
                        monthsToInsert,
                        yearsToInsert,
                        initYear,
                        initMonth,
                        invalidMonths);

                    //if (verifyTransactionAfterPorfolioClosed(monthClosed, yearClosed, transactionFormatted.transaction_date)) {
                    if (isDateAfterClosedMonth(transactionFormatted.transaction_date, portfolioClosed)) {
                        transactionToInsert.push(transactionFormatted);
                    }

                    //console.log("INCLUINDO " + i + ": ", transactionFormatted);

                } else {

                    console.log("Tentando incluir 1: ", transactionLoop);

                    let responseFundByCnpj = await FundAPI.getFundByCnpj(transactionLoop['CNPJ']);

                    let testMonth = transactionLoop['dataFormatada'].substring(3, 5);
                    //Teste para saber se existe algum erro na data de transação,
                    //algum registro apontando pra alguma data de anos diferentes
                    let testYear = transactionLoop['dataFormatada'].substring(6);

                    //Verificando se existem movimeentações para antes do início da carteira
                    if (initYear == testYear && parseInt(testMonth) <= initMonth) {

                        if (!invalidMonths.includes(parseInt(testMonth))) {
                            invalidMonths.push(parseInt(testMonth));
                        }

                    }

                    verifyingDate(transactionLoop['dataFormatada'],
                        monthsToInsert,
                        yearsToInsert,
                        initYear,
                        initMonth,
                        invalidMonths);

                    console.log("responseFundByCnpj: ", responseFundByCnpj);

                    //Existe o fundo cadastrado na base de dados
                    if (responseFundByCnpj.success && responseFundByCnpj.body.rows[0] != undefined) {

                        fundId = responseFundByCnpj.body.rows[0].id;

                        //Checando se o cliente já possui esse Ativo
                        // console.log("LOCAL ASSETS: ", listLocalClientAssets);
                        // console.log("transactionLoop['CNPJ']: ", transactionLoop['CNPJ']);
                        // console.log("transactionLoop.account_id: ", transactionLoop.account_id);
                        let assetId = checkIsClientAssetByCnpjAndAccount(listLocalClientAssets, transactionLoop['CNPJ'].toString().trim(), transactionLoop.account_id)

                        console.log("ASSSET ID: ", assetId);

                        // console.log("COMPARE: ");
                        // console.log(parseInt(transactionLoop['dataFormatada'].substring(6)))
                        // console.log(parseInt(moment.utc(clientOn.client.portfolio_init).format('YYYY')))
                        // console.log("Result: ", parseInt(transactionLoop['dataFormatada'].substring(6))
                        //     > parseInt(moment.utc(clientOn.client.portfolio_init).format('YYYY')));


                        if (!assetId &&
                            (assetsToCreate
                                .filter(el => el.fund_id == fundId && el.account_id == transactionLoop.account_id)).length == 0) {
                            //Checando se já não é um fundo a ser criado
                            //Caso não possua o ativo desse ser criado                        
                            const asset = {
                                account_id: transactionLoop.account_id,
                                number_account: transactionLoop['CC'],
                                fund_id: fundId,
                                balance: transactionLoop['VALOR'],
                                fundInfos: responseFundByCnpj.body.rows[0],
                                asset_init: transactionLoop['dataFormatada'],
                                quota_amount: transactionLoop['QUANTIDADE'],
                                transaction_date: transactionLoop['dataFormatada'],
                            }

                            //console.log("ACCOUNT NO ASSET: ", asset.account_id)

                            //Se data de movimentação for uma data antes do início da carteira o
                            //asset é criado e não é considerado como movimentação
                            //senão entra no IF abaixo e é criado o asset mas ele também uma movimentação

                            if (parseInt(transactionLoop['dataFormatada'].substring(6)) //Compara o ano da linha do excel 
                                > parseInt(moment.utc(clientOn.client.portfolio_init).format('YYYY'))) { //Com o ano de inicio da carteira

                                console.log("COMPARANDO: " + "[" + parseInt(transactionLoop['dataFormatada'].substring(6)) + "]" +
                                    ">" + "[" + parseInt(moment.utc(clientOn.client.portfolio_init).format('YYYY')) + "]")

                                const transactionFormatted = {

                                    //asset_id: assetId,
                                    account_id: asset.account_id,
                                    operation_id: transactionLoop['TIPO'],
                                    amount: transactionLoop['VALOR'],
                                    description: transactionLoop['DESCRICAO'] ? transactionLoop['DESCRICAO'].substring(0, 1000) : "",
                                    cnpj: transactionLoop['CNPJ'],
                                    transaction_date: transactionLoop['dataFormatada']

                                };

                                //console.log("TRANSACTION TAMBEM ASSET: ", transactionFormatted)

                                //Teste para saber se existe algum erro na data de transação,
                                //algum registro apontando pra alguma data de anos diferentes
                                let testYear = transactionLoop['dataFormatada'].substring(6);
                                //console.log("YEAR TEST: ", testYear)
                                if (!yearsToInsert.includes(testYear)) {
                                    yearsToInsert.push(testYear)
                                }

                                // if (verifyTransactionAfterPorfolioClosed(monthClosed, yearClosed, transactionFormatted.transaction_date)) {
                                if (isDateAfterClosedMonth(transactionFormatted.transaction_date, portfolioClosed)) {
                                    transactionToInsert.push(transactionFormatted);
                                }

                                //console.log("INCLUINDO " + i + ": ", transactionFormatted);

                                //No caso em que o asset é uma movimentação o saldo de criação é 0
                                asset.balance = 0.0;
                                asset.isTransaction = true; //utilizado pra controlar a criação do balance_validation
                                //quando é uma movimentação cria-se apenas um blance_validation aberto para o mês da movimentação
                            }

                            //console.log("ASSET TO CREATE: ", asset);
                            assetsToCreate.push(asset);

                        } else if (parseInt(transactionLoop['dataFormatada'].substring(6)) //Compara o ano da linha do excel, o ano deve ser maior ou igual ao ano de início da carteira 
                            >= parseInt(initYear)) {
                            //> parseInt(moment.utc(clientOn.client.portfolio_init).format('YYYY'))) {

                            const transactionFormatted = {
                                asset_id: assetId,
                                account_id: transactionLoop.account_id,
                                operation_id: transactionLoop['TIPO'],
                                amount: transactionLoop['VALOR'],
                                cnpj: transactionLoop['CNPJ'],
                                description: transactionLoop['DESCRICAO'] ? transactionLoop['DESCRICAO'].substring(0, 1000) : "",
                                transaction_date: transactionLoop['dataFormatada']
                            };

                            //console.log("REALMENTE INCLUINDO: ", transactionFormatted);

                            // if (verifyTransactionAfterPorfolioClosed(monthClosed, yearClosed, transactionFormatted.transaction_date)) {
                            if (isDateAfterClosedMonth(transactionFormatted.transaction_date, portfolioClosed)) {
                                transactionToInsert.push(transactionFormatted);
                            }
                        }

                        mapFunds[transactionLoop['CNPJ'] + "=" + transactionLoop['CC']] = fundId;

                    } else {

                        console.log("Tentando incluir 2: ", transactionLoop['CNPJ']);
                        console.log("ERROR: ", responseFundByCnpj.body)

                        let filtered = invalidsFunds.filter(el => el.cnpj == transactionLoop['CNPJ']);
                        if (filtered && filtered.length == 0) {
                            invalidsFunds.push({
                                fund_name: transactionLoop['FUNDO'],
                                cnpj: transactionLoop['CNPJ']
                            });
                        }

                    }

                }

            }


        }

        if (invalidColumns.length > 0
            || invalidsAccounts.length > 0
            || invalidsFunds.length > 0
            || accountsWhite > 0
            || yearsToInsert.length > 1
            || invalidMonths.length > 0
            || invalidDates.length > 0
            || invalidNoCnpjs > 0
        ) {
            console.log("Não será possível realizar as inserções")
            console.log("Colunas não encontradas: ", invalidColumns)
            console.log("Contas: ", invalidsAccounts)
            console.log("Contas em branco: ", accountsWhite)
            console.log("Fundos: ", invalidsFunds)
            console.log("Anos: ", yearsToInsert)
            console.log("invalidMonths: ", invalidMonths)
            console.log("invalidDates: ", invalidDates)
            console.log("invalidNoCnpjs: ", invalidNoCnpjs)
            //console.log("Meses: ", monthsToInsert)
            // dispatch(allActions.mainAlertActions.setMainAlert({
            //     show: true,
            //     type: 'warning',
            //     message: "Existem contas ou fundos não cadastradas, Contas: " + invalidsAccounts + " / " + "Fundos: " + invalidsFunds + " / " + "Anos:" + yearsToInsert
            // }))
        }
        //else {
        // console.log(`
        //     **********************
        //     * Realizar inserções *
        //     * ********************
        //     `)

        //checando se o ano já foi importado caso a planilha seja válida
        let alreadyImported = false;

        //lista dos meses que ainda não foram importados
        let newMonthsToInsert = [];
        //lista de meses a serem removidos da lista de inserção
        let monthsToRemoveFromInsert = [];

        //Meses que precisarão ser limpos pois surgiram novas transações
        const needCleanMonth = [];
        if (monthsToInsert.length > 0 && yearsToInsert.length == 1) {
            for (let i = 0; i < monthsToInsert.length; i++) {

                let responseAlreadyImported = await TransactionAPI.checkAlreadyImportedMonth(monthsToInsert[i].toString(),
                    yearsToInsert[0],
                    clientOn.client.id);

                console.log("responseAlreadyImported:", responseAlreadyImported);
                if (responseAlreadyImported.success) {

                    const transactionsInMonth = transactionToInsert.filter(el => el.transaction_date.substring(3, 5) == monthsToInsert[i].toString())

                    if (responseAlreadyImported.body
                        && responseAlreadyImported.body.rowCount == 0) {
                        //&& responseAlreadyImported.body.rowCount != transactionsInMonth.length) {

                        // if (responseAlreadyImported.body.rowCount != 0 && transactionsInMonth != 0) {
                        //     needCleanMonth.push(parseInt(monthsToInsert[i]));
                        // }

                        console.log("ADICIONANDO: ", monthsToInsert[i]);
                        newMonthsToInsert.push(monthsToInsert[i]);

                    } else {
                        monthsToRemoveFromInsert.push(monthsToInsert[i]);
                    }
                }

            }

        }

        console.log("TRANSACTIONS TO INSERT: ", transactionToInsert);
        console.log("needCleanMonth: ", needCleanMonth);

        //Caso existam meses a serem cadastrados

        //##################################################################
        //##################################################################
        //TROCAR TESTE DE JA INSERÇÃO DE MESES POR TESTE DE INSERÇÃO DE TRANSAÇÃO
        //let newTransactionsToInsert = [];
        let newTransactionsToInsert = transactionToInsert;
        if (newMonthsToInsert) {

            if (monthsToRemoveFromInsert.length > 0) {

                //Filtrando pelos meses que devem ser retirados, o filtro retorna tudos os itens que não se encontram na lista de meses a serem retirados
                newTransactionsToInsert = transactionToInsert.filter((el) => !monthsToRemoveFromInsert.includes(el.transaction_date.substring(3, 5)));

            } else {
                newTransactionsToInsert = transactionToInsert;
            }
        }
        //##################################################################
        //##################################################################

        //Guardando os dados a serem inseridos e exibindo modal de confirmação
        setDataToInsert({

            client: clientOn.client,

            assets: assetsToCreate,
            //transactions: transactionToInsert,
            needCleanMonth: needCleanMonth,
            transactions: newTransactionsToInsert,

            invalidColumns: invalidColumns,
            invalidsAccounts: invalidsAccounts,
            invalidsFunds: invalidsFunds,
            invalidMonths: invalidMonths,
            accountsWhite: accountsWhite,
            yearsToInsert: yearsToInsert,
            monthsToInsert: monthsToInsert,
            newMonthsToInsert: newMonthsToInsert,
            invalidDates: invalidDates,
            invalidNoCnpjs: invalidNoCnpjs,

            alreadyImported: alreadyImported,

        });

        dispatch(allActions.fullLoadActions.setFullLoad({
            show: false,
            message: ""
        }))

        setShowImportModal(true);

        // }
    }

    async function doInserts(data) {

        let allSuccess = true;

        let transactionsToInsert = data.transactions
        let listLocalClientAssets = clientAssets ? clientAssets : [];

        //Caso hajam meses que necessitaram ser limpos, array com os que já foram
        const monthsAlreadyDeleted = [];

        dispatch(allActions.fullLoadActions.setFullLoad({
            show: true,
            message: "Cadastrando Movimentações..."
        }))

        console.log("TRANSACTIONS TO INSERT: ", transactionsToInsert);

        for (let i = 0; i < transactionsToInsert.length; i++) {

            //console.log("####################################################");
            // const monthTransaction = parseInt(transactionsToInsert[i].transaction_date.substring(3, 5));
            // if (!monthsAlreadyDeleted.includes(monthTransaction) && data.needCleanMonth.includes(monthTransaction)) {
            //     const responseDeleteTransactionsInMonth = await deleteClientTransactionsInMonth(data.client.id, monthTransaction);
            // }

            let transactionLoop = transactionsToInsert[i];

            if (!transactionLoop.asset_id) {
                let assetId = checkIsClientAssetByCnpjAndAccount(listLocalClientAssets, transactionLoop.cnpj, transactionLoop.account_id)
                transactionLoop.asset_id = assetId;
            }


            console.log("transactionLoop: ", transactionLoop);

            //console.log("Incluindo: ", transactionLoop)
            dispatch(allActions.fullLoadActions.setFullLoad({
                show: true,
                message: "Cadastrando movimentações... " + parseFloat((i + 1) / transactionsToInsert.length * 100).toFixed(2) + "%"
            }))

            let responseInsertTransaction = await TransactionAPI.createTransaction(transactionLoop);

            if (!responseInsertTransaction.success) {
                allSuccess = false;
            }
            console.log("Sucesso: ", responseInsertTransaction.success)

        }

        if (allSuccess) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: "Movimentações cadastradas com sucesso!"
            }))
        } else {
            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: "Erro ao cadastrar uma ou mais movimentações"
            }))
        }

        setData(undefined)
        setDataListFormatted(undefined)

        setClientAccounts([])
        setTransactions(undefined)
        setAssetsFormatted(undefined);
        setQuotasModelDivergence(null);
        setFullDiaryPl(undefined);
        setMapFullDiarySegregation(undefined);
        setMapFullDiarySegment(undefined);
        setInitPortfolioQuota(undefined);
        setInitPortfolioQuotaBySegregation(undefined);
        setInitPortfolioQuotaBySegment(undefined);
        setRentPortfolioInMonth(undefined);
        setRentPortfolioInMonthMoney(undefined);
        setCheckedJustToConciliations(false);
        setDataToInconsistentTitlesModal();
        setEnableDivergentTitles(false)

        //console.log(getAssetInfos());
        //getClientAccountsAndTransactions(clientOn.client.id, clientOn.client.selectedMonth, clientOn.client.selectedYear);
        // dispatch(allActions.innerLoadActions.setInnerLoad({
        //     show: true,
        //     loadMessage: 'Carregando informações...',
        //     cod: codsInnerLoad.balancesCollectionScreen
        // }));
        setInnerLoad({ loadMessage: "Carregando informações" })

        console.log("POS UPLOAD MOVS");
        console.log('clientOn.client.selectedMonth: ', clientOn.client.selectedMonth);
        console.log('clientOn.client.selectedYear: ', clientOn.client.selectedYear);

        loadInfosAssets(clientOn.client.id,
            clientOn.client.selectedMonth,
            clientOn.client.selectedYear,
            null,
            true, clientOn.client.portfolio_init, isClientAbleToCurrentMonth);

        //get datas das transações
        // const responseDates = await getDatesWithTrasactions(clientOn.client.id);

        // if (responseDates.success) {

        //     console.log("RESPONSE DATES: ", responseDates.body.rows);
        //     if (responseDates.body.rows && responseDates.body.rows.length > 0) {
        //         formatTransactionsMonthsAndYears(responseDates.body.rows)
        //     }

        // }

        //Atualizar datas dos selects de data da Dashboard
        //Não há mais necessidade de atualização de selects de data;
        //clientOn.client.updateInfosClient = true;
        //dispatch(allActions.clientActions.setClient(clientOn.client));


        getDataToCreateTransaction();
    }

    function getAccountIdByAccountNumber(accountNumber) {

        //console.log("PROCURANDO ACC: ", accountNumber)
        let accounts = clientAccounts.filter(el => el.number_account == accountNumber);
        //console.log("ACCOUNTS: ", clientAccounts)

        if (accounts.length == 1) {
            return accounts[0].id
        } else {
            return "NOT_FOUND"
        }

    }

    async function getAccountIdByAccountNumberAndFundCnpj(accountNumber, cnpj) {

        //console.log("PROCURANDO ACC: ", accountNumber)
        //let accounts = clientAccounts.filter(el => el.number_account == accountNumber && el.cod == instituitionCod);
        const accounts = clientAccounts.filter(el => el.number_account == accountNumber);
        console.log("ACCOUNTS: ", clientAccounts);

        if (accounts.length == 1) {

            return accounts[0].id

        } else if (accounts.length > 1) {

            const accountAsset = await doGetAccountIdByNumberAccountAndCnpjAsset(accountNumber, cnpj);
            return accountAsset;

        } else {

            return "NOT_FOUND";

        }

    }

    function handleModalImport(doImport) {

        handleCloseFab(false);
        setShowImportModal(false)
        resetImportVariables();
        if (doImport) {
            doInserts(dataToInsert);
        }
    }

    function handleModalOffAssets(doAction) {

        setShowOffAssetsValidateModal(false)
        if (doAction) {

            handleLaunchWalletWithConciliationCheck(true);
        }

    }

    async function handleAmortizationToCreateModal(doAction) {

        setShowAmortizationToCreateModal(false)
        if (doAction) {

            let allSuccess = true;
            dispatch(allActions.fullLoadActions.setFullLoad({
                show: true,
                message: 'Criando amortizações...'
            }));

            for (let i = 0; i < amortizationsToCreate.length; i++) {

                const amortization = amortizationsToCreate[i];

                const amortizationToCreate = {
                    title_asset_id: amortization.titleAssetId,
                    operation_id: 3, //amortização
                    amount: parseFloat(amortization.valueAmortization),
                    transaction_date: moment.utc(amortization.dateCoupon).format("DD/MM/YYYY"),
                }

                const response = await TransactionAPI.createTransaction(amortizationToCreate);
                if (response.success) {

                    //Amortização criada com sucesso

                } else {

                    allSuccess = false;

                }
            }

            if (allSuccess) {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: "Amortizações criadas com sucesso!"
                }))

            } else {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "Falha ao criar uma ou mais das amortizações!"
                }))

            }

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }));

            // dispatch(allActions.innerLoadActions.setInnerLoad({
            //     show: true,
            //     loadMessage: 'Carregando informações...',
            //     cod: codsInnerLoad.balancesCollectionScreen
            // }));
            setInnerLoad({ loadMessage: "Carregando informações" })

            setClientAccounts([])
            setTransactions(undefined)
            setAssetsFormatted(undefined);
            setQuotasModelDivergence(null);
            setSegregationOnScreen(segregation);

            setFullDiaryPl(undefined);
            setMapFullDiarySegregation(undefined);
            setMapFullDiarySegment(undefined);
            setInitPortfolioQuota(undefined);
            setInitPortfolioQuotaBySegregation(undefined);
            setInitPortfolioQuotaBySegment(undefined);
            setRentPortfolioInMonth(undefined);
            setRentPortfolioInMonthMoney(undefined);
            setCheckedJustToConciliations(false);
            setDataToInconsistentTitlesModal();
            setEnableDivergentTitles(false)

            loadInfosAssets(clientOn.client.id,
                clientOn.client.selectedMonth,
                clientOn.client.selectedYear,
                segregation,
                true, clientOn.client.portfolio_init, isClientAbleToCurrentMonth);
        }

    }

    const useRowStyles = makeStyles({
        green: {
            color: unoTheme.greenMoney,
        },
        red: {
            color: unoTheme.errorColor,
        },
        blue: {
            color: "blue",
            fontWeight: 'bold'
        },
        tableTh: {
            fontWeight: 'bold'
        },
        rowFooter: {
            '& > *': {
                borderBottom: 'unset',
            }
        },
        statusOk: {
            fontSize: '18px',
            verticalAlign: 'middle',
            color: unoTheme.greenMoney,
            fill: unoTheme.greenMoney,
        },
        statusPendent: {
            fontSize: '18px',
            verticalAlign: 'middle',
            color: unoTheme.warningColor,
            fill: unoTheme.warningColor,
        },

        labelConc: {
            fontSize: '0.7em',
            color: unoTheme.defaultTextColor,
        },

        offAssetRow: {
            backgroundColor: '#fff93657 !important',
        },

        needCheckRentRow: {
            backgroundColor: '#fff93657 !important',
        }
    });

    function getLastDayQuotaInMonthByOtherAssets() {

        let maxLength = null;
        let model = null;
        if (assetsFormatted && assetsFormatted.length) {
            assetsFormatted.forEach(assetLoop => {

                const row = assetLoop.quotas_anbima;
                if (row && row.length) {
                    if (model == null) {

                        maxLength = row.length;
                        model = _.cloneDeep(row);

                    } else if (model != null) {
                        if (row.length > maxLength) {
                            maxLength = row.length;
                            model = _.cloneDeep(row);
                        }
                    }
                }

            })

        }
        if (model && model.length) {

            const lastDayQuotaInMonth = model[model.length - 1].data_referencia;
            console.log("RETURN LAST DAY QUOTA: ", lastDayQuotaInMonth);
            return lastDayQuotaInMonth;
        }

        return null;

    }

    function checkAbleMonthToLoauch() {
        return clientOn
            && clientOn.client
            && clientOn.client.selectedYear && clientOn.client.selectedMonth
            && isDateAfterClosedMonth(moment.utc(new Date(clientOn.client.selectedYear, parseInt(clientOn.client.selectedMonth) - 1, 1)).format("DD/MM/YYYY"),
                clientOn.client.portfolio_closed,
                false)
            && !isDateBeforeInit(getFirstDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear), clientOn.client.portfolio_init);
    }

    const renderReturnColumn = (row, returnColumnType) => {

        const isTitleAsset = row.title_id;



        if (isTitleAsset) {

            if (isGenericTitle(row) && !isConsigTitle(row))
                return <TableCell align='right'>-</TableCell>

            return <TableCell align="right">{

                row.noQuotas ? ("-") :
                    (returnColumnType == 'percent' ?

                        (!row.noBeforeQtdQuota ? (
                            isClientAbleToCurrentMonth ?
                                applyMaskAmount(row.rentPercentInMonth, null) :
                                applyMaskAmount(getRentMonthTitle(row))
                        ) + "%" : "-")
                        :
                        (
                            (!row.noBeforeQtdQuota ?

                                (

                                    //row.balance_now != undefined && row.totalPeriodRent ?                                            
                                    row.balance_now != undefined || isClientAbleToCurrentMonth ?
                                        //applyMaskAmount(row.balance_now * row.totalPeriodRent / 100, true)
                                        (
                                            isClientAbleToCurrentMonth ?
                                                applyMaskAmount(row.rentMoneyInMonth, true) :
                                                applyMaskAmount(getRentInMoneyMonthTitle(row), true)
                                        )
                                        :
                                        "-"
                                )

                                :

                                "-"
                            )
                        )
                    )

            }</TableCell>
        }

        return <TableCell align="right">{

            (returnColumnType == 'percent' ?
                (!row.noBeforeQtdQuota ? applyMaskAmount(getInMonthRentFundInPortfolio(row), null, true) + "%" : "-")
                :
                (
                    (!row.noBeforeQtdQuota ?

                        (

                            row.balance_now != undefined || isClientAbleToCurrentMonth ?
                                applyMaskAmount(row.rentMoneyInMonth, true)
                                :
                                "-"
                        )

                        :

                        "-"
                    )
                )
            )

        }</TableCell>
    }

    function Row(props) {
        const { row, index, offAsset } = props;
        const classes = useRowStyles();

        //console.log("offAsset: ", offAsset);

        let infosConc = [];

        //Caso seja um fundo de diversos assets
        if (row.subAssets && row.subAssets.length > 0) {

            for (let i = 0; i < row.subAssets.length; i++) {
                const subAsset = row.subAssets[i];
                if (!checkIsSameBalance(subAsset.pl, subAsset.balance_now) || !checkIsSameQuotas(subAsset.quota_amount_now, subAsset.qtd_quotas_sensibilized_final)) {
                    //console.log("SUBASSET: ", subAsset)
                    infosConc.push(<p key={'aprover-' + subAsset.id + '-' + i} style={{ marginBottom: (i != row.subAssets.length - 1 ? '12px' : '6px') }}>{`${subAsset.agency ? 'Ag:' + subAsset.agency + " -" : ""}` + " cc: " + subAsset.number_account + ": "}<span style={{ marginLeft: '5px', marginRight: '5px' }}>{subAsset.balance_now_conc ? <CheckCircleIcon className={classes.statusOk} /> : <ReportProblemIcon className={classes.statusPendent} />}</span>{subAsset.balance_now_conc ? 'Por: ' + subAsset.conc_name : ''}</p>)
                    if (i != row.subAssets.length - 1) {
                        infosConc.push(<Divider key={'divider-' + subAsset.id + '-' + i} />)
                    }
                }

            }
        } else {

            //Caso seja apenas um asset
            const subAsset = row;
            if (!checkIsSameBalance(subAsset.pl, subAsset.balance_now) || !checkIsSameQuotas(subAsset.quota_amount_now, subAsset.qtd_quotas_sensibilized_final)) {
                infosConc.push(<p key={'aprover-' + subAsset.id} style={{ marginBottom: '12px' }}>{`${subAsset.agency ? 'Ag:' + subAsset.agency + " -" : ""}` + " cc: " + subAsset.number_account + ": "}<span style={{ marginLeft: '5px', marginRight: '5px' }}>{subAsset.balance_now_conc ? <CheckCircleIcon className={classes.statusOk} /> : <ReportProblemIcon className={classes.statusPendent} />}</span>{subAsset.balance_now_conc ? 'Por: ' + subAsset.conc_name : ''}</p>)
            }

        }

        // console.log("BALANCE BEFORE: ", parseFloat(row.balanceBefore))
        // console.log("RESULT AMOUNT: ", row.resultAmount)
        // console.log("BALANCE NOW: ", parseFloat(row.balanceNow))        
        //console.log("ROW: ", row)        

        //corrigindo -0,00
        if (row.pl < 0 && (row.pl * (-1) < 0.01)) {
            row.pl = 0;
        }

        const isSegmentRow = row.labelSegment;
        const isArticleRow = row.labelArticle;

        const isTitleAsset = row.title_id;
        if (isTitleAsset) {
            // console.log("IS TITLE");
            // console.log("row.title_id: ", row.title_id);
            row.titleCod = getTitleCod(row);
            row.taxDescription = '';

            if (row.indexer) {
                if (row.indexer == "CDI") {
                    row.taxDescription += row.indexer + (row.indexer_percent ? ": " + applyMaskAmount(row.indexer_percent) + "%" : '');
                } else {
                    row.taxDescription += row.indexer;
                }
            } else if (row.pre_tax) {
                row.taxDescription += "Taxa pré: " + applyMaskAmount(row.pre_tax) + "%";
            }

            if (row.marking == MARKING_CURVE) {
                if (row.rentPercentInMonth > OUT_OF_MARKET_RENT_TITLE) {
                    row.needCheckRent = true;
                } else {
                    row.needCheckRent = false;
                }
            }


        }

        if (isSegmentRow) {
            if (checkedJustToConciliations) return null;
            return (
                <React.Fragment>
                    <TableRow className={"divisor-table-1"}>
                        <TableCell align="left">
                            {isSegmentRow}
                        </TableCell>
                        <TableCell align="right">
                            {row.totalBalanceBefore != null ? applyMaskAmount(row.totalBalanceBefore, true) : '-'}
                        </TableCell>
                        <TableCell align="right">
                            {row.totalBalanceNow != null ? applyMaskAmount(row.totalBalanceNow, true) : '-'}
                        </TableCell>
                        <TableCell align="center" >
                        </TableCell>
                        <TableCell align="left">
                        </TableCell>
                        <TableCell align="right">
                            {returnColumnType === 'money'
                                ? (row.totalRentMoney != null ? applyMaskAmount(row.totalRentMoney, true) : '-')
                                : '-'}
                        </TableCell>
                    </TableRow>
                </React.Fragment >
            )
        }

        if (isArticleRow) {
            if (checkedJustToConciliations) return null;
            return (
                <React.Fragment>
                    <TableRow className={"divisor-table-2"}>
                        <TableCell align="left">
                            {isArticleRow}
                        </TableCell>
                        <TableCell align="right">
                            {row.totalBalanceBefore != null ? applyMaskAmount(row.totalBalanceBefore, true) : '-'}
                        </TableCell>
                        <TableCell align="right">
                            {row.totalBalanceNow != null ? applyMaskAmount(row.totalBalanceNow, true) : '-'}
                        </TableCell>
                        <TableCell align="center" >
                        </TableCell>
                        <TableCell align="left">
                        </TableCell>
                        <TableCell align="right">
                            {returnColumnType === 'money'
                                ? (row.totalRentMoney != null ? applyMaskAmount(row.totalRentMoney, true) : '-')
                                : '-'}
                        </TableCell>
                    </TableRow>
                </React.Fragment >
            )
        }

        if (row) {
            return (
                <React.Fragment>
                    <TableRow
                        className={[classes.root, offAsset ? classes.offAssetRow : '', isTitleAsset && (row.needCheckRent || row.expiredWithoutRescue) ? classes.needCheckRentRow : ''].join(' ')}
                        onClick={() => !offAsset ? dispatch(allActions.rightContentActions.setRightContent({
                            path: isTitleAsset ? 'detailTitleBalanceCollection' : 'detailBalanceCollection',
                            data: row,
                            selectedMonth: clientOn.client.selectedMonth,
                            selectedYear: clientOn.client.selectedYear,
                            accounts: clientAccounts,
                            assets: clientAssets,
                            titleAssets: clientTitleAssets,
                            operations: clientOperations,
                            lastDayQuotaInMonth: row.special ? getLastDayQuotaInMonthByOtherAssets() : null,
                            ableToAddSpecialQuota: row.special ? checkAbleMonthToLoauch() : null,
                        })) : null}>

                        <TableCell align="left">
                            {isTitleAsset ?
                                <div>
                                    <div>{row.titleCod}</div>
                                    {
                                        row.label_title_type == GENERIC_ASSET_TITLES_TYPE ?
                                            <div style={{ color: 'black', fontWeight: '900', fontSize: '12px' }}>{row.asset_name}</div>
                                            :
                                            <div style={{ color: 'black', fontWeight: '900', fontSize: '12px' }}>{row.marking} <span style={{ fontSize: '10px', color: 'blue' }}>( Título [Tax: {row.taxDescription}])</span>
                                                {
                                                    //Amortização e resgate no mesmo dia do diário (ex.: cupom pago junto do vencimento)
                                                    row.amortizationWithRescueDate ?
                                                        <LightTooltip title={`Amortização e resgate no mesmo dia (${moment.utc(row.amortizationWithRescueDate).format('DD/MM/YYYY')}): o cupom é considerado na rentabilidade do mês`} placement="right" arrow>
                                                            <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#5C4300', backgroundColor: unoTheme.warningColor, borderRadius: '4px', padding: '1px 6px', marginLeft: '4px' }}>( AMORTIZAÇÃO NO DIA DO RESGATE )</span>
                                                        </LightTooltip>
                                                        : null
                                                }
                                            </div>
                                    }
                                </div>
                                :
                                <div>
                                    <div>{row.fund_name}</div>
                                    <div style={{ color: 'black', fontWeight: '900', fontSize: '12px' }}>{row.cnpj} {row.special ? <span style={{ fontSize: '10px', color: 'blue' }}>( ESPECIAL )</span> : null}</div>
                                </div>
                            }


                        </TableCell>

                        {/* Saldo anterior */}
                        {
                            row.balance_before == null ?
                                <TableCell align="right">{'Não informado'}</TableCell>
                                :
                                <TableCell align="right"
                                    className={row.balance_before < 0 ? classes.red : classes.green}>{applyMaskAmount(row.balance_before, true)}</TableCell>
                        }

                        {/* Saldo atual sensibilizado */}
                        {/* Caso tenha sido conciliado deve ser exibido o saldo validado */}
                        {

                            row.balance_now_conc || checkAssetsAndSubAssetsSameBalances(row) ?

                                //Se conciliado exibe o saldo validado
                                <TableCell align="right"
                                    className={row.balance_now < 0 ? classes.red : classes.green}>{applyMaskAmount(row.balance_now, true)}</TableCell>
                                :

                                //Caso não tenha sido validado exibe o sensibilizado
                                <>
                                    {
                                        //Caso não haja saldo anterior apresenta-se apenas o valor das movimentações
                                        row.balance_before == null || row.noBeforeQtdQuota ?
                                            // <TableCell align="right"
                                            //     className={row.resultAmount < 0 ? classes.red : classes.green}>{applyMaskAmount(row.resultAmount, true)}</TableCell>
                                            //Caso não haja saldo anterior ou quantidade de quota anterior não exibe-se nada
                                            <TableCell align="right">-</TableCell>
                                            :
                                            //Caso haja se exibe o PL ou o resultAmount                                        
                                            //Se o pl for igual a 0 não houve conta, exibe-se o result amount sensibilizado com o balance-before
                                            <>
                                                {

                                                    row.pl != null ?
                                                        <TableCell align="right"
                                                            className={row.pl < 0 ?
                                                                classes.red
                                                                :
                                                                classes.green
                                                            }>{

                                                                applyMaskAmount(row.pl, true)
                                                            }</TableCell>
                                                        :

                                                        <TableCell align="right">Não informado</TableCell>
                                                }

                                            </>


                                    }
                                </>
                        }

                        {/* Icon validado ou não */}
                        {
                            offAsset || isClientAbleToCurrentMonth ?

                                <TableCell align="center" className='noPaddingCell'>
                                    {'-'}
                                </TableCell>
                                :
                                <>
                                    {

                                        //Caso o saldo não conste na validação de saldos ou o saldo valdido seja diferente do pl
                                        //Ou o saldo de cotas esteja diferente dos demais
                                        //Ou fundo que foi liquidado e saldo final seja diferente de 0
                                        //Deverá ser exibido o icon alerta amarelo (verde apenas caso o saldo tenha sido conciliado)
                                        row.needConciliation

                                            ?

                                            <>
                                                {

                                                    //Para o caso de não informe na tela de validação de saldo a info tooltip é Validação de saldo não informada
                                                    row.balance_now == null || row.noBeforeQtdQuota ?

                                                        <LightTooltip title={row.noBeforeQtdQuota ? "Quantidade de cotas não informada" : "Validação de saldo não informada"} placement="right" arrow>
                                                            <TableCell align="center" className='noPaddingCell'>
                                                                <ReportProblemIcon className={classes.statusPendent} />
                                                            </TableCell>
                                                        </LightTooltip>

                                                        :

                                                        <>
                                                            {

                                                                //No caso de o saldo estar diferente mas ter sido conciliado
                                                                //Apresenta-se o icon verde
                                                                row.balance_now_conc ?
                                                                    <TableCell align="center" className='noPaddingCell'>
                                                                        <CheckCircleIcon className={classes.statusOk} />
                                                                    </TableCell>
                                                                    :

                                                                    //Caso em que o PL é mesmo difenrete do saldo validado e ainda não foi conciliado
                                                                    //icon amarelo                                                                                                    
                                                                    <LightTooltip title={
                                                                        row.noQuotasCod == '404' ? 'Erro ao buscar as cotas do fundo, virifique se ele possui o cadastro do código ANBIMA' : applyMaskAmountFreeDecimals(row.pl - row.balance_now, true)
                                                                    } placement="right" arrow>
                                                                        <TableCell align="center" className='noPaddingCell'>
                                                                            <ReportProblemIcon className={classes.statusPendent} />
                                                                        </TableCell>
                                                                    </LightTooltip>
                                                            }
                                                        </>
                                                }

                                            </>

                                            :

                                            //Caso em que o saldo validado informado já é igual ao saldo sensibilizado
                                            <TableCell align="center" className='noPaddingCell'>
                                                <CheckCircleIcon className={classes.statusOk} />
                                            </TableCell>

                                    }
                                </>
                        }


                        {/* CONCILIADO  */}
                        {
                            isClientAbleToCurrentMonth ?
                                <TableCell align="left"></TableCell>
                                :
                                <TableCell align="left"
                                    className={classes.labelConc}>

                                    {
                                        offAsset ?

                                            <span>Resgatado Total</span>

                                            :

                                            <LightTooltip title={<div>{infosConc}</div>} placement="bottom" arrow>

                                                <span>{
                                                    row.balance_now_conc ?
                                                        'Conciliado'
                                                        :
                                                        (
                                                            //checkIsSameBalance(row.pl, row.balance_now) ?
                                                            checkAssetsAndSubAssetsSameBalances(row) ?
                                                                ''
                                                                :
                                                                (row.inProgressConc ? 'Em conciliação' : 'Aguardando conciliação')
                                                        )

                                                }</span>

                                            </LightTooltip>




                                    }
                                </TableCell>
                        }



                        {/* Retorno mensal */}
                        {renderReturnColumn(row, returnColumnType)}

                    </TableRow>
                </React.Fragment >
            );
        }


    }

    function formatTransactionsMonthsAndYears(data) {

        let yearsWithMonths = {}
        let years = [];
        data.forEach(element => {

            let splitted = element.monthyear.split('/');
            let m = splitted[0]
            let y = splitted[1]
            if (!yearsWithMonths[y]) {
                yearsWithMonths[y] = [];
                years.push(parseInt(y));
            }

            if (!yearsWithMonths[y].includes(m)) {
                yearsWithMonths[y].push(parseInt(m));
                yearsWithMonths[y].sort(function sortfunction(a, b) {
                    return (a - b)
                });
            }
        });

        years.sort(function sortfunction(a, b) {
            return (a - b)
        });

        //setYears(years);
        //setMonths(getMonthsByArray(yearsWithMonths[years[0]]))
        clientOn.client.months = getMonthsByArray(yearsWithMonths[years[0]]);
        clientOn.client.years = years;

        //Inicializando selectedMonth e selectedYear do client com os primeiros registros obtidos
        clientOn.client.selectedMonth = parseInt(yearsWithMonths[years[0]][0]);
        clientOn.client.selectedYear = parseInt(years[0]);
        dispatch(allActions.clientActions.setClient(clientOn.client));

        return yearsWithMonths;
    }

    function handleActionDivergentTitles(action) {

        setDataToInconsistentTitlesModal();

        if (action) {
            setEnableDivergentTitles(true);
        } else {
            setEnableDivergentTitles(false);
        }
    }

    useEffect(() => {
        if (enableDivergentTitles) {
            handleLaunchWalletWithConciliationCheck();
        }
    }, [enableDivergentTitles])

    const CONC_DIF_BALANCES = 0.15;
    const CONC_DIF_QUOTAS = 10;

    function itemExceedsLimit(item) {
        return item.subRows.some(sub => {
            const balanceExceeds = Math.abs((sub.pl || 0) - (sub.balance_now || 0)) > CONC_DIF_BALANCES;
            const quotaExceeds = Math.abs((sub.qtd_quotas_sensibilized_final || 0) - (sub.quota_amount_now || 0)) > CONC_DIF_QUOTAS;
            return balanceExceeds || quotaExceeds;
        });
    }

    function renderAssetNameForModal(row) {
        const isTitleAsset = row.title_id;
        if (isTitleAsset) {
            return (
                <div>
                    <div>{row.titleCod || getTitleCod(row)}</div>
                    {row.label_title_type == GENERIC_ASSET_TITLES_TYPE
                        ? <div style={{ color: 'black', fontWeight: '900', fontSize: '12px' }}>{row.asset_name}</div>
                        : <div style={{ color: 'black', fontWeight: '900', fontSize: '12px' }}>{row.marking} <span style={{ fontSize: '10px', color: 'blue' }}>( Título [Tax: {row.taxDescription}])</span></div>
                    }
                </div>
            );
        }
        return (
            <div>
                <div>{row.fund_name}</div>
                <div style={{ color: 'black', fontWeight: '900', fontSize: '12px' }}>
                    {row.cnpj} {row.special ? <span style={{ fontSize: '10px', color: 'blue' }}>( ESPECIAL )</span> : null}
                </div>
            </div>
        );
    }

    function canConciliateRow(row) {
        const isAdmin = checkUserIsRole(currentUser, [roles.admin, roles.superadmin]);
        if (row.balance_now == undefined || row.balance_now == null) return false;
        const balanceDiffOk = row.pl - row.balance_now >= 0
            ? (row.pl - row.balance_now <= CONC_DIF_BALANCES || isAdmin)
            : (((row.pl - row.balance_now) * (-1)) <= CONC_DIF_BALANCES || isAdmin);
        const quotaDiffOk = row.qtd_quotas_sensibilized_final - row.quota_amount_now >= 0
            ? (row.qtd_quotas_sensibilized_final - row.quota_amount_now <= CONC_DIF_BALANCES || isAdmin)
            : (((row.qtd_quotas_sensibilized_final - row.quota_amount_now) * (-1)) <= CONC_DIF_BALANCES || isAdmin);
        return (balanceDiffOk && quotaDiffOk) || (row.special && isAdmin);
    }

    function getConciliationItems() {
        if (!assetsFormatted) return [];
        const isAdvisorOrAbove = checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor]);
        const items = [];
        assetsFormatted.forEach(row => {
            if (row.labelSegment || row.labelArticle) return;
            const pendingSubRows = [];
            if (row.subAssets && row.subAssets.length > 0) {
                row.subAssets.forEach(sub => {
                    const isSame = checkIsSameBalance(sub.pl, sub.balance_now)
                        && checkIsSameQuotas(sub.quota_amount_now, sub.qtd_quotas_sensibilized_final);
                    if (!isSame && !sub.balance_now_conc) pendingSubRows.push(sub);
                });
            } else {
                const isSame = checkIsSameBalance(row.pl, row.balance_now)
                    && checkIsSameQuotas(row.quota_amount_now, row.qtd_quotas_sensibilized_final);
                if (!isSame && !row.balance_now_conc) pendingSubRows.push(row);
            }
            const needsSpecialQuota = !row.is_poupanca
                && row.special
                && checkAbleMonthToLoauch()
                && !checkAssetsAndSubAssetsSameBalances(row)
                && isAdvisorOrAbove;
            if (pendingSubRows.length > 0 || needsSpecialQuota) {
                items.push({ parentRow: row, subRows: pendingSubRows, needsSpecialQuota: !!needsSpecialQuota });
            }
        });
        return items;
    }

    async function handleLaunchWalletWithConciliationCheck(validatedOffAssets) {

        //Obtendo portfolioClosed do cliente pois algúem pode ter lançado em outra tela
        const responsePortfolioClosed = await ClientAPI.getPortfolioClosed(clientOn.client.id);
        if (!responsePortfolioClosed.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Falha ao obter data de fechamento da carteira'
            }))
            return;
        }

        //Checar se o último mês validado é mesmo o 
        //anterior a esse que está tentando-se fechar portfolio_closed
        let splittedClosedMonth = null
        let nextMonth = 0
        let nextYear = 0

        if (clientOn.client.portfolio_closed) {
            //No caso de já haver uma carteira fechada
            splittedClosedMonth = clientOn.client.portfolio_closed.split("/")
        } else {

            //Ainda não havia carteira fechada
            splittedClosedMonth = moment.utc(clientOn.client.portfolio_init).format("MM/YYYY").split("/")
        }

        nextMonth = parseInt(splittedClosedMonth[0]) + 1
        nextYear = parseInt(splittedClosedMonth[1])

        //No caso do mês ser 12
        if (nextMonth == 13) {
            nextMonth = 1;
            nextYear++;
        }

        if (clientOn.client.selectedMonth != nextMonth
            || clientOn.client.selectedYear != nextYear) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'A próxima carteira a ser fechada deve ser a do mês ' + getMonthName(nextMonth) + "/" + nextYear
            }))

            return;

        }

        let currentPortfolioClosed = responsePortfolioClosed.body;
        if (clientOn.client.portfolio_closed) {
            clientOn.client.portfolio_closed = clientOn.client.portfolio_closed.trim();
        }
        if (currentPortfolioClosed) {
            currentPortfolioClosed = currentPortfolioClosed.trim();
        }
        if (clientOn.client.portfolio_closed != currentPortfolioClosed) {
            clientOn.client.portfolio_closed = currentPortfolioClosed;
            dispatch(allActions.clientActions.setClient(clientOn.client));
        }


        //Verificando consistencia de saldos
        setInconsistentBalancesValidations();
        setShowInconsistentBalancesValidationsModal(false);
        const allBalancesValidations = await BalancesValidationsAPI.getBalancesWithAssetInitsInfosByMonthAndYear(clientOn.client.id, clientOn.client.selectedMonth, clientOn.client.selectedYear);
        const momentClientInit = moment.utc(clientOn.client.portfolio_init);
        const assetsWithExtraInitBalances = [];
        allBalancesValidations.body.rows.forEach(element => {

            const momentAssetInit = moment.utc(element.asset_init);
            const monthAssetInit = momentAssetInit.month() + 1;
            const yearAssetInit = momentAssetInit.year();

            const balanceLoop = element.balance != null ? parseFloat(element.balance) : 0;
            const quotaAmountLoop = element.quota_amount != null ? parseFloat(element.quota_amount) : 0;

            if (moment.utc(element.asset_init).isAfter(momentClientInit)
                && monthAssetInit == element.month_validation
                && yearAssetInit == element.year_validation
                && (balanceLoop != 0 || quotaAmountLoop != 0)) {
                assetsWithExtraInitBalances.push(element);
            }
        });

        if (assetsWithExtraInitBalances.length) {

            setInconsistentBalancesValidations(assetsWithExtraInitBalances)
            setShowInconsistentBalancesValidationsModal(true);
            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))
            return;
        }

        const items = getConciliationItems();
        if (items.length === 0) {
            launchWallet(validatedOffAssets);
        } else {
            setPendingLaunchArgs(validatedOffAssets);
            setShowConciliationModal(true);
        }
    }

    async function handleConciliateAllAndLaunch() {
        setConciliationLoading(true);
        const items = getConciliationItems();
        for (const item of items) {
            for (const subRow of item.subRows) {
                if (subRow.balance_now_id && canConciliateRow(subRow)) {
                    const response = await ClientAPI.setBalanceReconciliaded(
                        subRow.balance_now_id,
                        currentUser.user.id,
                        true
                    );
                    if (response.success) {
                        updateConcilio(subRow.balance_now_id);
                    }
                }
            }
        }
        setConciliationLoading(false);
        setShowConciliationModal(false);
        launchWallet(pendingLaunchArgs);
    }

    //validatedOffAssets: ativos que estão com saldos não informados para o mês em questão de
    //mas que poderão ser salvos automaticmante como 0
    async function launchWallet(validatedOffAssets) {
        dispatch(allActions.fullLoadActions.setFullLoad({
            show: true,
            message: "Lançando carteira..."
        }))

        //Obtendo portfolioClosed do cliente pois algúem pode ter lançado em outra tela
        const responsePortfolioClosed = await ClientAPI.getPortfolioClosed(clientOn.client.id);
        if (!responsePortfolioClosed.success) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Falha ao obter data de fechamento da carteira'
            }))
            return;
        }

        //Checar se o último mês validado é mesmo o 
        //anterior a esse que está tentando-se fechar portfolio_closed
        let splittedClosedMonth = null
        let nextMonth = 0
        let nextYear = 0

        if (clientOn.client.portfolio_closed) {
            //No caso de já haver uma carteira fechada
            splittedClosedMonth = clientOn.client.portfolio_closed.split("/")
        } else {

            //Ainda não havia carteira fechada
            splittedClosedMonth = moment.utc(clientOn.client.portfolio_init).format("MM/YYYY").split("/")
        }

        nextMonth = parseInt(splittedClosedMonth[0]) + 1
        nextYear = parseInt(splittedClosedMonth[1])

        //No caso do mês ser 12
        if (nextMonth == 13) {
            nextMonth = 1;
            nextYear++;
        }

        if (clientOn.client.selectedMonth != nextMonth
            || clientOn.client.selectedYear != nextYear) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'A próxima carteira a ser fechada deve ser a do mês ' + getMonthName(nextMonth) + "/" + nextYear
            }))

            return;

        }

        if (fullDiaryPl == NO_INIT_QUOTA) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Falha ao lançar carteira, cota inicial não encontrada!'
            }))

            return;
        }

        //A consulta de ativos pode devolver o MESMO ativo repetido quando há linha duplicada em
        //fund_local_quotas (ou rent_funds): o saldo entra em dobro no PL, o PL de abertura descola
        //da cota do mês anterior e o descolamento inteiro vira rentabilidade do 1º dia. Lançar
        //assim gravaria em client_rents uma cota errada — e client_rents nunca sofre UPDATE, só
        //reset e reinserção. Por isso bloqueia.
        const duplicatedPortfolioAssets = findDuplicatedPortfolioAssets(assetsFormatted);
        if (duplicatedPortfolioAssets.length) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))

            const duplicatedNames = duplicatedPortfolioAssets
                .map(group => group[0].fund_name ? group[0].fund_name : ('ativo #' + group[0].asset_id))
                .join(', ');

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Falha ao lançar carteira: ativo duplicado na consulta (' + duplicatedNames
                    + '). Verifique cotas locais duplicadas para esse fundo na análise da carteira.'
            }))

            return;
        }

        //Um dia com pl/newPl não-finito seria gravado como null em client_rents (JSON.stringify
        //converte NaN em null) e viraria "R$ NaN" na tela de retornos, contaminando também o PL de
        //abertura do dia seguinte. Como client_rents não sofre UPDATE, bloqueia-se antes de gravar.
        const invalidDiaryDays = findInvalidDiaryDays({
            'carteira': fullDiaryPl,
            ...mapFullDiarySegregation,
            ...mapFullDiarySegment,
        });

        if (invalidDiaryDays.length) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))

            console.error("Dias inválidos no diário da carteira: ", invalidDiaryDays);

            const invalidDates = [...new Set(invalidDiaryDays.map(el => formatAnbimaDateToPt(el.date)))].join(', ');

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Falha ao lançar carteira: PL inválido no(s) dia(s) ' + invalidDates
                    + '. Verifique as cotas dos fundos nesses dias antes de lançar.'
            }))

            return;
        }

        const dateRentMoney = getLastDayInMonthByMonthAndYear(clientOn.client.selectedMonth, clientOn.client.selectedYear);

        const divergentNTNBBalancesTitles = [];

        const clientId = clientOn.client.id;
        const monthRent = clientOn.client.selectedMonth;
        const yearRent = clientOn.client.selectedYear;


        let formattedMonth = clientOn.client.selectedMonth + "/" + clientOn.client.selectedYear

        //Verificar se os ativos do mês possuem seus saldos validados e/ou conciliados            
        let allConc = true;
        let accountsWithNoBalance = []; //verificar se todas as contas possuem saldo informado no mês de lançamento
        let accountsWithNoBalanceToAutomaticZero = []; //verificar se todas as contas possuem saldo informado no mês de lançamento
        //let accountsWithNoBalanceToCreate = []; //verificar se todas as contas possuem saldo informado no mês de lançamento
        let assetsNoInfos = [];
        let allQtdQuotasOk = true;
        let allQtdQuotasNoOk = [];

        let noQuotasNow = [] //Verificar se existem cotas comdinheiro salvas localmente
        let noQuotasBefore = [] //Verificar se existem cotas comdinheiro salvas localmente

        let assetsNoQtdQuotasValidation = [];


        const justAssetsFormatted = assetsFormatted.filter(el => !el.labelArticle && !el.labelSegment);

        console.log("ASSETS TO LAUNCH: ", justAssetsFormatted);
        console.log("offAssets: ", offAssets);
        console.log("fullDiaryPl: ", fullDiaryPl);



        justAssetsFormatted.forEach(element => {

            //Verificando se os ativos possuem as informações cadastrais
            //if (!element.special && !element.dados_cadastrais) {
            const isTitleAsset = element.title_id;
            if (!isTitleAsset) {
                if (!element.dados_cadastrais && !element.no_infos_api) {
                    assetsNoInfos.push(element);
                }
            }

            if (!isTitleAsset) {

                if (
                    //!element.special &&
                    //(!element.quotas_anbima || (element.quotas_anbima.filter(el => !el.replicated).length === 0))
                    (!element.quotas_anbima || (element.quotas_anbima.filter(el => !el.replicated).length === 0))
                ) {

                    noQuotasNow.push(element);

                }

                if (!element.is_poupanca && (!element.quotas_anbima_before || element.quotas_anbima_before.length === 0)) {
                    if (element.uno_date_quota_init) {
                        console.log("IS BEFORE: ", moment.utc(element.uno_date_quota_init).isBefore(getLastDayMonthAgo(monthRent, yearRent)))
                        console.log(moment.utc(element.uno_date_quota_init));
                        console.log(getLastDayMonthAgo(monthRent, yearRent));
                        if (moment.utc(element.uno_date_quota_init).isBefore(getLastDayMonthAgo(monthRent, yearRent))) {
                            noQuotasBefore.push(element);
                        }
                    } else {
                        noQuotasBefore.push(element);
                    }

                }

                if (element.quota_amount_now == null || !element.quota_amount_before == null) {
                    assetsNoQtdQuotasValidation.push(element);
                }

            } else {

                if (needQuotasTitle(element)) {
                    if (!element.title_local_quotas || element.title_local_quotas.length === 0) {

                        noQuotasNow.push(element);

                    }

                    if (!element.title_local_quotas_before || element.title_local_quotas_before.length === 0) {
                        noQuotasBefore.push(element);
                    }
                }


                //Verificando se existem saldos muito divergentes em NTNB
                if (checkAssetTitleDivergentBalance(element)) {
                    divergentNTNBBalancesTitles.push(element);
                }
            }

            //Caso tenha elementos segregados deve verificar os saldos de cada elemento
            if (element.subAssets) {

                element.subAssets.forEach(elementSegregated => {

                    if (!checkIsSameBalance(elementSegregated.pl, elementSegregated.balance_now)
                        || !checkIsSameQuotas(elementSegregated.quota_amount_now, elementSegregated.qtd_quotas_sensibilized_final)) {

                        if (!elementSegregated.balance_now_conc) {
                            //console.log("E não tem balance_conc: ", elementSegregated.balance_now_conc);
                            allConc = false;
                        }

                    }

                    //Verificando se o saldo atual de cotas é igual ao informado na validação
                    // if (!checkIsSameQuotas(elementSegregated.quota_amount_now, elementSegregated.qtd_quotas_sensibilized_final)) {
                    //     allQtdQuotasOk = false;
                    //     allQtdQuotasNoOk.push(elementSegregated);
                    // }

                });

            } else {

                if (!checkIsSameBalance(element.pl, element.balance_now)
                    || !checkIsSameQuotas(element.quota_amount_now, element.qtd_quotas_sensibilized_final)) {
                    //if (element.balance_before + element.resultAmount != element.balance_now) {

                    if (!element.balance_now_conc) {
                        //console.log("E não tem balance_conc: ", element.balance_now_conc);
                        allConc = false;
                    }

                }

                // if (!checkIsSameQuotas(element.quota_amount_now != element.qtd_quotas_sensibilized_final)) {
                //     allQtdQuotasOk = false;
                //     allQtdQuotasNoOk.push(element);
                // }
            }

            //console.log("ALL CONC: ", allConc)
        });

        //Checando fundos que precisam estar totalmente resgatados
        const needEndFundZeroBalanceConciliation = justAssetsFormatted.some(el => !checkAssetsAndSubAssetsEndFundoZeroBalance(el, firstDayMonthDetail, endDayMonthDetail));
        if (needEndFundZeroBalanceConciliation) allConc = false;

        if (divergentNTNBBalancesTitles.length && !enableDivergentTitles) {

            setDataToInconsistentTitlesModal({
                message: 'Alguns ativos de título apresetaram saldos divergentes',
                titles: divergentNTNBBalancesTitles
            });
            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))
            return;

        }


        const launchDate = stringPtDateToMoment('01/' + clientOn.client.selectedMonth.toString().padStart(2, '0') + '/' + clientOn.client.selectedYear, true);
        //verificando se os saldos de todas as contas foram informados para esse mês
        accountsWithNoBalance = clientAccounts.filter(el =>
            launchDate.isSameOrAfter(el.account_init, 'month') && el.balance_now == null);

        accountsWithNoBalanceToAutomaticZero = accountsWithNoBalance.filter(el =>
            el.account_end_date && launchDate.isSameOrAfter(el.account_end_date, 'month')
        )

        //Verificando se a conta está atrelada a algum fundo em questão
        //Apenas as contas que possuem ativo relacionado
        // let idsAccountsNoBalanceToCreate = [];
        // preAccountsWithNoBalance.forEach(acc => {
        //     if (justAssetsFormatted.some(el => el.account_id == acc.id) && !idsAccountsNoBalance.includes(acc.id)) {
        //         accountsWithNoBalanceToCreate.push(acc);
        //         idsAccountsNoBalance.push(acc.id);
        //     }
        // });

        validatorFundsClientRents(clientId, monthRent, yearRent, justAssetsFormatted);

        // console.log("ON LAUNCH fullDiaryPl: ", fullDiaryPl);

        // return;

        //Veriricando se existem títulos com rentabilidades destoantes

        if (
            justAssetsFormatted.some(el => el.title_id && el.needCheckRent)
            &&
            !checkUserIsRole(currentUser, [roles.superadmin])
        ) {
            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Existem títulos com rentablidades superiores a ' + OUT_OF_MARKET_RENT_TITLE
            }))
            return;
        }

        //Título vencido cujo resgate não foi lançado: o PL some do fullDiaryPl sem contrapartida e a
        //cota do mês - que é gravada em client_rents e vira a cota inicial do mês seguinte - nasce com
        //o saldo inteiro do título como prejuízo. Sem liberação para superadmin: aqui o dado está
        //incompleto (o mesmo dinheiro costuma estar em dobro, no título e no fundo que o recebeu),
        //então lançar por cima propaga o erro para todos os meses à frente.
        const expiredTitlesWithoutRescue = justAssetsFormatted.filter(el => el.title_id && el.expiredWithoutRescue);

        if (expiredTitlesWithoutRescue.length) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Título vencido sem resgate lançado: '
                    + expiredTitlesWithoutRescue
                        .map(el => getTitleCod(el, true))
                        .join(', ')
            }))
            return;
        }

        if (allConc
            && assetsNoInfos.length == 0
            && allQtdQuotasOk
            && noQuotasNow.length == 0
            && noQuotasBefore.length == 0
            //Caso não hajam contas sem saldos ou as contas sem saldos sejam contas que entrarão com saldo 0
            && (accountsWithNoBalance.length == 0 || (accountsWithNoBalance.length == accountsWithNoBalanceToAutomaticZero.length))
            && assetsNoQtdQuotasValidation.length == 0
            && !justAssetsFormatted.some(fund => fund.validatedRentFund === false)) {

            console.log("FECHAR: ", formattedMonth)

            //Atualizar balances_validations com o totalPeriodRent dos ativos, necessário para evitar processamento desnecessário em outras telas 
            let allSuccessUpdateRents = true;

            ///////////////////////////////////////////
            //Incluir assets zerados nas atualizações//
            ///////////////////////////////////////////

            //Checar se existem ativos totalmente resgatados sem a informação de saldo 0 para o mês 
            let needValidateOffAssets = false;
            if (!validatedOffAssets && offAssets && offAssets.length > 0) {

                let noBalancesOffAssets = offAssets.filter(el => el.balance_now == null);
                if (noBalancesOffAssets && noBalancesOffAssets.length > 0) {

                    needValidateOffAssets = true;
                    //Chama o modal de aviso
                    setDataOffAssets({
                        offAssets: offAssets,
                        month: nextMonth
                    })
                    setShowOffAssetsValidateModal(true);
                    dispatch(allActions.fullLoadActions.setFullLoad({
                        show: false,
                    }))
                }

            }

            if (!needValidateOffAssets || validatedOffAssets) {
                if (offAssets && offAssets.length > 0) {

                    for (let k = 0; k < offAssets.length; k++) {
                        const oa = offAssets[k];

                        //Caso não haja balance_now_id o saldo não foi informado deve ser salvo o balance_validation zerado para esse ativo
                        if (oa.balance_now_id == null
                            && stringPtDateToMoment('01/' + clientOn.client.selectedMonth.toString().padStart(2, '0') + '/' + clientOn.client.selectedYear, true)
                                .isSameOrAfter(oa.asset_init, 'month')) {
                            let responseOaBalance = await ClientAPI.createBalanceValidation({
                                account_id: null,
                                asset_id: oa.id,
                                balance: 0,
                                quota_amount: 0,
                                balance_validation_id: undefined,
                                month_validation: clientOn.client.selectedMonth,
                                year_validation: clientOn.client.selectedYear,
                            });

                            if (responseOaBalance.success) {
                                console.log("SUBINDO SALDO CRIADO AUTOMATICAMENTE");
                                // let responseOaRent = await updateRentInBalancesValidation(oa.balance_now_id, 0, null);
                                // if (responseOaRent.success) {

                                //     //Rentabilidade cadastrada com sucesso
                                // } else {
                                //     console.error("Falha ao salvar saldo de ativo resgatado totalmente");
                                // }
                            } else {
                                console.error("Falha ao salvar saldo de ativo resgatado totalmente");
                            }
                        }



                    }

                }

                //Se necessário salvar os saldos de contas automaticamente com zero
                if (accountsWithNoBalance.length != 0 && accountsWithNoBalance.length == accountsWithNoBalanceToAutomaticZero.length) {
                    for (let index = 0; index < accountsWithNoBalanceToAutomaticZero.length; index++) {
                        const acc = accountsWithNoBalanceToAutomaticZero[index];
                        const responseOaBalance = await ClientAPI.createBalanceValidation({
                            account_id: acc.id,
                            asset_id: null,
                            balance: 0,
                            quota_amount: 0,
                            balance_validation_id: undefined,
                            month_validation: clientOn.client.selectedMonth,
                            year_validation: clientOn.client.selectedYear,
                        });

                        if (responseOaBalance.success) {
                            console.log("Saldo 0 de conta finalizada cadastrado corretamente");
                        } else {
                            console.error("Falha ao salvar saldo de ativo resgatado totalmente");
                        }

                    }
                }

                //Verificando se é necessário o salvamento da cota inicial da carteira
                if (clientOn.client.portfolio_closed == null) {
                    const responseRent = await ClientAPI.saveClientRent(initPortfolioQuota);
                    console.log("RESPOSTA SAVING FIRST QUOTA: ", responseRent);

                    //Salvando cotas iniciais segregadas
                    if (clientOnScreen.is_cotization_segregation) {
                        Object.entries(initPortfolioQuotaBySegregation).map(async ([key, segregatedInitQuota]) => {
                            const response = await ClientAPI.saveClientRentSegregation({
                                segregation_cod: key,
                                ...segregatedInitQuota
                            });
                        })

                        console.log("initPortfolioQuotaBySegmentxxx: ", initPortfolioQuotaBySegment);
                        Object.entries(initPortfolioQuotaBySegment).map(async ([key, segmentInitQuota]) => {
                            const response = await ClientAPI.saveClientRentSegment({
                                segment_cod: key,
                                ...segmentInitQuota
                            });

                        })

                    }
                }

                const fundsFormatted = justAssetsFormatted.filter(el => !el.title_id) //filter para que não sejam considerados os títulos
                for (let i = 0; i < fundsFormatted.length; i++) {

                    const assetLoop = fundsFormatted[i]
                    const responseRentFund = await doSaveFundClientRent(assetLoop.validatedRentFund);

                }

                console.log('justAssetsFormatted.filter(el => el.title_id): ', justAssetsFormatted.filter(el => el.title_id));

                //Salvando rentabilidades dos títulos
                const titlesFormatted = justAssetsFormatted.filter(el => el.title_id) //filter para que não sejam considerados os títulos
                for (let i = 0; i < titlesFormatted.length; i++) {

                    const assetTitleLoop = titlesFormatted[i]
                    const responseRentTitle = await doSaveTitleClientRent(clientId, monthRent, yearRent, assetTitleLoop);

                }

                //Caso as rentabilidades tenham sido salvas corretamente
                if (allSuccessUpdateRents) {

                    if (fullDiaryPl) {


                        Object.entries(fullDiaryPl).map(async ([key, row]) => {

                            //adicionando informações necessárias
                            let clientRent = {
                                client_id: clientOn.client.id,
                                date_quota: key,
                                month: clientOn.client.selectedMonth,
                                year: clientOn.client.selectedYear,
                                new_pl: row.newPl,
                                ...row,
                            }

                            //console.log("Salvando rent diário: ", clientRent);
                            let response = await ClientAPI.saveClientRent(clientRent)
                            if (!response.success) {
                                allSuccessUpdateRents = false;
                            }

                        })


                        if (clientOnScreen.is_cotization_segregation) {



                            Object.entries(mapFullDiarySegregation).map(async ([segragationCod, segregatedFullDiary]) => {

                                if (segregatedFullDiary != null) {
                                    //adicionando informações necessárias
                                    Object.entries(segregatedFullDiary).map(async ([key, row]) => {

                                        //adicionando informações necessárias
                                        let clientRent = {
                                            client_id: clientOn.client.id,
                                            date_quota: key,
                                            month: clientOn.client.selectedMonth,
                                            year: clientOn.client.selectedYear,
                                            new_pl: row.newPl,
                                            segregation_cod: segragationCod,
                                            ...row,
                                        }

                                        //console.log("Salvando rent diário: ", clientRent);
                                        let response = await ClientAPI.saveClientRentSegregation(clientRent)
                                        if (!response.success) {
                                            allSuccessUpdateRents = false;
                                        }

                                    })
                                }

                            })

                            //Somando rentabilidades por segmentCod
                            const mapSegmentRentMoney = {};
                            justAssetsFormatted.forEach(asset => {
                                const segmentCod = getSegmentKeyById(asset.segment_id);
                                if (!mapSegmentRentMoney[segmentCod]) {
                                    mapSegmentRentMoney[segmentCod] = 0;
                                }
                                mapSegmentRentMoney[segmentCod] += asset.rentMoneyInMonth;
                            });

                            Object.entries(mapFullDiarySegment).map(async ([segmentCod, segmentFullDiary]) => {

                                if (segmentFullDiary != null) {
                                    //adicionando informações necessárias
                                    Object.entries(segmentFullDiary).map(async ([key, row]) => {

                                        //adicionando informações necessárias
                                        let clientRent = {
                                            client_id: clientOn.client.id,
                                            date_quota: key,
                                            month: clientOn.client.selectedMonth,
                                            year: clientOn.client.selectedYear,
                                            new_pl: row.newPl,
                                            segment_cod: segmentCod,
                                            ...row,
                                        }

                                        //console.log("Salvando rent diário: ", clientRent);
                                        let response = await ClientAPI.saveClientRentSegment(clientRent)
                                        if (!response.success) {
                                            allSuccessUpdateRents = false;
                                        }

                                    })
                                }

                                //Salvar informações de saldos
                                const responseRentMoneySegment = await ClientAPI.saveClientRentMoneyBySegment({
                                    client_id: clientOn.client.id,
                                    segment_cod: segmentCod,
                                    rent_money: mapSegmentRentMoney[segmentCod] || 0,
                                    month: clientOn.client.selectedMonth,
                                    year: clientOn.client.selectedYear,
                                    money_date: dateRentMoney,
                                });

                            })

                        }



                    } else {
                        if (justAssetsFormatted && justAssetsFormatted.length === 0 && offAssets && offAssets.length > 0) {

                            //Cliente que não possui nenhuma aplicação no mês, mas deve ser lançado a rentabilidade da carteira
                            let responselastQuota = await ClientAPI.getClientLastQuota(clientId, monthRent, yearRent);
                            //console.log('responselastQuota: ', responselastQuota);
                            const daysToRent = getBusinessDaysInMonth(monthRent, yearRent);
                            //console.log('daysToRent: ', daysToRent);
                            if (responselastQuota.success
                                && responselastQuota.body
                                && responselastQuota.body.length === 1) {
                                for (let i = 0; i < daysToRent.length; i++) {
                                    const day = daysToRent[i];

                                    //adicionando informações necessárias
                                    let clientRent = {
                                        ...responselastQuota.body[0],
                                        date_quota: day,
                                        month: monthRent,
                                        year: yearRent,
                                        rent_day: 0,
                                    }

                                    //console.log("Salvando rent diário: ", clientRent);
                                    let response = await ClientAPI.saveClientRent(clientRent)
                                    if (!response.success) {
                                        allSuccessUpdateRents = false;
                                    }
                                }
                            }

                        }
                    }

                    //return;


                    let response = await ClientAPI.updateClientClosedMonth(clientOn.client.id,
                        formattedMonth.toString().trim())
                    if (response.success) {

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))
                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'success',
                            message: 'Carteira de [ ' + getMonthName(formattedMonth) + '/' + clientOn.client.selectedYear + ' ] lançada com sucesso!'
                        }))

                        clientOn.client.portfolio_closed = formattedMonth;
                        //Atualizar datas dos selects de data da Dashboard
                        clientOn.client.updateInfosPortfolio = true;

                        console.log("CLIENT ON: ", clientOn);
                        //Avançando automaticamente a tela de coleta para o próximo mês
                        let nextMonth = clientOn.client.selectedMonth + 1;
                        if (nextMonth == 13
                            || (nextMonth > clientOn.client.months.length) //visto que os meses estão em um array começando por 0, se o nextMonth for 7 ele tem que ser <= a months.length
                        ) {

                            //Caso seja dezembro mantem-se no mesmo ano e espera-se a troca do usuário
                            //ou no caso de ser um mês que não possui movimntações
                            nextMonth--;

                        }

                        clientOn.client.selectedMonth = nextMonth;

                        //Registrando logAction

                        const responseLogAction = await saveLogPortfolioLaunch(currentUser.user.id, clientId, portfolioClosedToDate(formattedMonth));

                        dispatch(allActions.clientActions.setClient(clientOn.client))

                        //Enviando Email de lançamento de carteira
                        //Usa monthRent/yearRent (mês lançado): selectedMonth já foi avançado para o próximo mês acima
                        //Envia apenas quando o mês lançado é o mais recente liberado para cotas (ou posterior), não em relançamentos de meses antigos
                        const lastMonthYear = getLastMonthYearAbleToQuotas();
                        if (yearRent * 12 + monthRent >= lastMonthYear.year * 12 + lastMonthYear.month) {
                            const responseEmail = await sendLaunchPortofolioEmail(clientOn.client.id, monthRent, yearRent);
                            if (!responseEmail.success) {
                                dispatch(allActions.mainAlertActions.setMainAlert({
                                    show: true,
                                    type: 'warning',
                                    message: responseEmail.noManagers
                                        ? 'Carteira de [ ' + getMonthName(monthRent) + '/' + yearRent + ' ] lançada, mas o cliente não possui gestores ativos para receber o e-mail de lançamento'
                                        : 'Carteira de [ ' + getMonthName(monthRent) + '/' + yearRent + ' ] lançada, mas não foi possível enviar o e-mail de lançamento aos gestores (' + responseEmail.sent + ' de ' + responseEmail.total + ' enviados)'
                                }))
                            }
                        }
                        //END EMAIL

                    } else {

                        dispatch(allActions.fullLoadActions.setFullLoad({
                            show: false,
                        }))
                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'error',
                            message: 'Erro ao fechar carteira de ' + formattedMonth
                        }))
                    }
                } else {

                    dispatch(allActions.fullLoadActions.setFullLoad({
                        show: false,
                    }))
                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: 'Erro ao atualizar rentabilidades dos saldos'
                    }))
                }
            }



        } else {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
            }))

            if (!allQtdQuotasOk) {

                console.log("QUOTAS NO OK: ", allQtdQuotasNoOk);
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: 'Existem ativos com quantidade de COTAS atuais diferentes do que foi informado na VALIDAÇÃO'
                }))

            } else {

                if (!allConc) {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'warning',
                        message: 'Os saldos de todos os ativos devem estar validados e/ou conciliados'
                    }))

                } else {


                    if ((accountsWithNoBalance.length != accountsWithNoBalanceToAutomaticZero.length) && accountsWithNoBalance.length > 0) {
                        console.log("ACCOUNTS NO BALANCE: ", accountsWithNoBalance);
                        console.log("ACCOUNTS NO BALANCE TO ZERO: ", accountsWithNoBalanceToAutomaticZero);
                        dispatch(allActions.mainAlertActions.setMainAlert({
                            show: true,
                            type: 'warning',
                            message: 'Algumas contas não possuem saldo informado para o período ' + getMonthName(formattedMonth) + '/' + clientOn.client.selectedYear + ', verifique em Ativos e Contas > Aba Contas',
                        }))
                    } else {

                        if (assetsNoInfos.length > 0) {

                            console.log("ASSETS NO INFOS: ", assetsNoInfos);
                            setFundsToInconsistentFundsModal({
                                message: 'Alguns ativos ainda não possuem Dados Cadastrais salvos localmente',
                                funds: assetsNoInfos,
                            })
                            setShowInconsistentFundsModal(true);

                            // dispatch(allActions.mainAlertActions.setMainAlert({
                            //     show: true,
                            //     type: 'warning',
                            //     message: 'Alguns ativos ainda não possuem Dados Cadastrais salvos localmente'
                            // }))

                        } else if (justAssetsFormatted.some(fund => fund.validatedRentFund === false)) {

                            console.log("FUNDOS COM RENT FUND INCONSISTENTES: ", justAssetsFormatted.filter(fund => fund.validatedRentFund === false));
                            dispatch(allActions.mainAlertActions.setMainAlert({
                                show: true,
                                type: 'warning',
                                message: 'Alguns fundos possuem inconsistência na rentabilidade'
                            }))

                        } else if (noQuotasNow.length > 0) {

                            setFundsToInconsistentFundsModal({
                                message: 'Fundos sem informações de cotas mensais para o mês atual',
                                funds: noQuotasNow,
                            })
                            setShowInconsistentFundsModal(true);

                            // dispatch(allActions.mainAlertActions.setMainAlert({
                            //     show: true,
                            //     type: 'warning',
                            //     message: 'Existem fundos sem informações de cotas mensais para o mês atual'
                            // }))

                        } else if (noQuotasBefore.length > 0) {

                            const monthBefore = monthRent - 1 == 0 ? 12 : monthRent - 1;
                            const yearBefore = monthBefore == 12 ? yearRent - 1 : yearRent;

                            setFundsToInconsistentFundsModal({
                                message: 'Fundos sem informações de cotas mensais para o mês anterior',
                                funds: noQuotasBefore,
                                //Fundos que podem ter as cotas buscadas na Comdinheiro: títulos,
                                //fundos especiais e fundos com cota por cliente ficam de fora
                                updatableFunds: selectFundsToBulkQuotasUpdate(noQuotasBefore),
                                period: { month: monthBefore, year: yearBefore },
                            })
                            setInconsistentFundsProgress({ running: false });
                            setInconsistentFundsResult(null);
                            setShowInconsistentFundsModal(true);
                            // console.log('noQuotasBefore: ', noQuotasBefore);
                            // dispatch(allActions.mainAlertActions.setMainAlert({
                            //     show: true,
                            //     type: 'warning',
                            //     message: 'Existem fundos sem informações de cotas mensais para o mês anterior'
                            // }))

                        } else if (assetsNoQtdQuotasValidation.length > 0) {
                            setFundsToInconsistentFundsModal({
                                message: 'Fundos sem informação de quantidade de cota para o mês atual e/ou anterior',
                                funds: assetsNoQtdQuotasValidation,
                            })
                            setShowInconsistentFundsModal(true);
                        }
                    }



                }
            }

        }





    }

    //SpeedDial
    const [direction, setDirection] = React.useState('up');
    const [openFab, setOpenFab] = React.useState(false);
    const [hidden, setHidden] = React.useState(false);

    const handleDirectionChange = (event) => {
        setDirection(event.target.value);
    };

    const handleHiddenChange = (event) => {
        setHidden(event.target.checked);
    };

    const handleCloseFab = () => {
        setOpenFab(false);
    };

    const handleOpenFab = (openFab) => {
        setOpenFab(openFab);
    };

    function doClickinputFile() {
        handleCloseFab();
        inputFile.current.click()
    }

    const [appearFab, setAppearFab] = useState(true);

    // const {
    //     fileToImport,
    //     doResetImportVariables,
    //     cleanResetImportVariables
    // } = props    

    async function loadInfosAssets(clientId, month, year, accountRegimeId, doQuotas, portfolioInit, isAbleCurrentMonth) {

        let currentMonthIndexes = null;

        if (isAbleCurrentMonth) {
            const responseIndexes = await SelicCdiIpcaAPI.get(month, year);
            if (responseIndexes.success && responseIndexes.body.rowCount > 0) {
                const row = responseIndexes.body.rows[0];
                currentMonthIndexes = {
                    cdiMonthPercent: parseFloat(row.cdi),
                    ipcaMonthPercent: parseFloat(row.ipca),
                    selicMonthPercent: parseFloat(row.selic),
                };
            } else {
                if (checkUserIsRole(currentUser, [roles.superadmin])) {
                    setShowSelicCdiIpcaModal(true);
                } else {
                    setShowSelicCdiIpcaWarning(true);
                }
                return;
            }
        }

        //Caso o month e o year sejam undefined (quando ainda não existem movimentações cadastradas)
        //dentro do percusso desse método deve se parar no momento em que trás as contas
        let responseInfosAssets = await getAssetInfos(clientId,
            month,
            year,
            accountRegimeId,
            doQuotas, portfolioInit, undefined, undefined, isAbleCurrentMonth, currentMonthIndexes);

        if (responseInfosAssets.success) {

            //Atualizando componentes da tela
            setClientAccounts(responseInfosAssets.accounts);

            setOffAssets(responseInfosAssets.offAssets);

            //adicionando offAssets aos assets formatted com propriedade que informa que não
            //estão ativos nas rentabilizações

            //setAssetsFormatted(responseInfosAssets.assetsFormatted);
            const formatteds = groupFundsBySegmentAndArticle(responseInfosAssets.assetsFormatted);

            formatteds.forEach(row => {

                const needConciliation = row.balance_now == null
                    || !checkAssetsAndSubAssetsSameBalances(row)
                    || !checkAssetsAndSubAssetsSameFinalQuotas(row)
                    || !checkAssetsAndSubAssetsEndFundoZeroBalance(row, firstDayMonthDetail, endDayMonthDetail)

                if (needConciliation) {
                    row.needConciliation = true;
                } else {
                    row.needConciliation = false;
                }

            });

            setQuotasModelDivergence(responseInfosAssets.quotasModelDivergence || null);
            setAssetsFormatted(formatteds);

            // const checkConsistencyRents = [];
            // formatteds.forEach(element => {

            //     const rentMonth = getInMonthRentFundInPortfolio(element);
            //     const rentMoneyMonth = getRentInMoneyMonthTitle(element);
            //     if ((rentMonth > 0 && rentMoneyMonth < 0) || (rentMonth < 0 && rentMoneyMonth > 0)) {
            //         checkConsistencyRents.push({
            //             cnpj: element.cnpj,
            //             r1: rentMonth,
            //             r2: rentMoneyMonth,
            //         })
            //     }

            // });
            // console.log("CHECAGEM CONSISTENCIA RENTABILIDADES: ", checkConsistencyRents);

            setFullDiaryPl(responseInfosAssets.fullDiaryPl);
            setMapFullDiarySegregation(responseInfosAssets.mapFullDiarySegregation);
            setMapFullDiarySegment(responseInfosAssets.mapFullDiarySegment);
            setInitPortfolioQuota(responseInfosAssets.initPortfolioQuota);
            setInitPortfolioQuotaBySegregation(responseInfosAssets.initPortfolioQuotaBySegregation);
            setInitPortfolioQuotaBySegment(responseInfosAssets.initPortfolioQuotaBySegment);

            // if (responseInfosAssets.fullDiaryPl && responseInfosAssets.initPortfolioQuota) {
            //     if (Object.values(responseInfosAssets.fullDiaryPl).length) {
            //         setRentPortfolioInMonth(((Object.values(responseInfosAssets.fullDiaryPl).pop().quota_value / responseInfosAssets.initPortfolioQuota.quota_value) - 1) * 100);
            //     }

            // }

            setRentPortfolioInMonth(getRentPortfolioInMonth(responseInfosAssets.fullDiaryPl, responseInfosAssets.initPortfolioQuota));
            setTotalResultAmount(responseInfosAssets.totalResultAmount);
            setTotalBeforeAmount(responseInfosAssets.totalBeforeAmount);
            setTotalDisponibilityInAccounts(responseInfosAssets.totalDisponibilityInAccounts);

            //Indicar se transação irregular. Caso não faça parte dos ativos do mês.
            //Se faz necessário pois houve caso em que foi cadastrada movimentação de título que não estava vigente na carteira
            responseInfosAssets.transactions.forEach(element => {
                if (element.title_id) {
                    if (!responseInfosAssets.assetsFormatted.some(el => el.id == element.title_asset_id)) {
                        element.invalidTransaction = true;
                    }
                } else {

                    if (!responseInfosAssets.assetsFormatted.some(el =>
                        el.id == element.asset_id
                        ||
                        (el.subAssets && el.subAssets.some(el => el.id === element.asset_id))
                    )) {
                        element.invalidTransaction = true;
                    }


                }
            });

            const listTransactions = responseInfosAssets.transactions;
            setTransactions(listTransactions);
            const seenCnpjs = new Set();
            const fundsInMovs = listTransactions
                .filter(el => {
                    if (seenCnpjs.has(el.fund_cnpj)) return false;
                    seenCnpjs.add(el.fund_cnpj);
                    return true;
                })
                .map(el => ({
                    id: el.fund_id,
                    cnpj: el.fund_cnpj,
                    fund_name: el.fund_name
                }))
            setAllFundsInMovs(
                fundsInMovs
            );
            const resultTrasactionsAmounts = responseInfosAssets.transactions.reduce(
                (previous, current) => previous + (
                    current.operation_id == 1 ? parseFloat(current.amount) : parseFloat(current.amount) * (-1)
                ),
                0
            );
            const resultTrasactionsApplications = responseInfosAssets.transactions.filter(el => el.operation_id === 1).reduce(
                (previous, current) => previous + parseFloat(current.amount),
                0
            );
            const resultTrasactionsResues = responseInfosAssets.transactions.filter(el => el.operation_id === 2).reduce(
                (previous, current) => previous + parseFloat(current.amount),
                0
            );
            setTotalAmountTransactions(resultTrasactionsAmounts);
            setTotalAmountTransactionsApplications(resultTrasactionsApplications);
            setTotalAmountTransactionsRescues(resultTrasactionsResues);

            //setRentPortfolioInMonthMoney(getPortfolioMonthRentInMoney(responseInfosAssets.totalResultAmount, resultTrasactionsAmounts, responseInfosAssets.totalBeforeAmount));
            setRentPortfolioInMonthMoney(responseInfosAssets.totalRentMoneyInMonth);
            setInvalidQuotas(responseInfosAssets.invalidQuotas);

            console.log("INFO ASSETS: ", responseInfosAssets);


            //Verificar role
            if (checkUserIsRole(currentUser,
                [roles.admin,
                roles.superadmin,
                roles.advisor])) {

                const amortizationsToCreate = verifyTitlesAmortizations(responseInfosAssets.assetsFormatted.filter(el => el.title_id));
                console.log('amortizationsToCreate: ', amortizationsToCreate)
                if (amortizationsToCreate && amortizationsToCreate.length) {


                    setAmortizationsToCreate(amortizationsToCreate);
                    setShowAmortizationToCreateModal(true)
                }
            }


        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: responseInfosAssets.message,
            }))
        }

        if (responseInfosAssets
            && responseInfosAssets.assetsFormatted
            && responseInfosAssets.assetsFormatted.length == 0
            // && responseInfosAssets.offAssets
            // && responseInfosAssets.offAssets.length == 0
        ) {

            setInnerLoad({
                emptyMessage: 'Nenhuma informação lançada para '
                    + getMonthName(clientOn.client.selectedMonth) + "/" + clientOn.client.selectedYear
            })
            // dispatch(allActions.innerLoadActions.setInnerLoad({
            //     show: true,
            //     emptyMessage: 'Nenhuma informação lançada para '
            //         + getMonthName(clientOn.client.selectedMonth) + "/" + clientOn.client.selectedYear,
            //     cod: codsInnerLoad.balancesCollectionScreen
            // }));

        } else {

            // dispatch(allActions.innerLoadActions.setInnerLoad({
            //     show: true,
            //     emptyMessage: 'Ainda sem informações de ativos para '
            //         + getMonthName(clientOn.client.selectedMonth) + "/" + clientOn.client.selectedYear
            // }));

            console.log("REMOVENDO INNER LOAD 1");
            // dispatch(allActions.innerLoadActions.setInnerLoad({
            //     show: false,
            //     cod: codsInnerLoad.balancesCollectionScreen
            // }));
            setInnerLoad(null)

        }



    }

    async function saveSelicCdiIpca() {
        setSelicCdiIpcaSaving(true);
        const response = await SelicCdiIpcaAPI.save({
            selic: parseFloatByPtCurrency(selicCdiIpcaForm.selic),
            ipca: parseFloatByPtCurrency(selicCdiIpcaForm.ipca),
            cdi: parseFloatByPtCurrency(selicCdiIpcaForm.cdi),
            month: clientOn.client.selectedMonth,
            year: clientOn.client.selectedYear,
        });
        setSelicCdiIpcaSaving(false);
        if (response.success) {
            setShowSelicCdiIpcaModal(false);
            setSelicCdiIpcaForm({ selic: '0,00', ipca: '0,00', cdi: '0,00' });
            await loadInfosAssets(
                clientOn.client.id,
                clientOn.client.selectedMonth,
                clientOn.client.selectedYear,
                clientOn.client.accountRegimeId,
                true, undefined, true
            );
        }
    }

    function doCreateAsset() {

        if (clientAccounts && clientAccounts.length > 0) {
            dispatch(allActions.rightContentActions.setRightContent({
                path: 'newAsset',
                data: {
                    allFunds: allFunds,
                    accounts: clientAccounts,
                },
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Para cadastrar um ativo você precisa cadastrar pelo menos uma conta'
            }))
        }
    }

    function doCreateAssetTitle() {

        if (clientAccounts && clientAccounts.length > 0) {
            dispatch(allActions.rightContentActions.setRightContent({
                path: 'newAssetTitle',
                data: {
                    accounts: clientAccounts,
                },
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Para cadastrar um ativo você precisa cadastrar pelo menos uma conta'
            }))
        }
    }

    function updateConcilio(balanceId) {

        if (balanceId) {
            console.log("Update concilio: ", balanceId);
            let newAssetsFormatted = [...assetsFormatted];

            for (let i = 0; i < newAssetsFormatted.length; i++) {
                const assetLoop = newAssetsFormatted[i];

                if (assetLoop.subAssets && assetLoop.subAssets.length > 0) {

                    for (let j = 0; j < assetLoop.subAssets.length; j++) {

                        let subAssetLoop = assetLoop.subAssets[j]
                        //console.log("SubAsset: ", subAssetLoop.balance_now_id);
                        if (subAssetLoop.balance_now_id == balanceId) {
                            subAssetLoop.balance_now_conc = true;
                            //console.log("SubAsset: ", subAssetLoop);
                        }

                    }

                } else {
                    if (assetLoop.balance_now_id == balanceId) {
                        assetLoop.balance_now_conc = true;
                    }
                }

            }

            newAssetsFormatted.forEach(element => {

                //console.log("///////");
                if (element.subAssets) {
                    //Conciliando conciliações
                    let allConc = true;
                    let groupConciliaded = false;

                    element.subAssets.forEach(elementSegregated => {

                        if (!checkIsSameBalance(elementSegregated.pl, elementSegregated.balance_now)
                            || !checkIsSameQuotas(elementSegregated.quota_amount_now, elementSegregated.qtd_quotas_sensibilized_final)) {

                            if (!elementSegregated.balance_now_conc) {

                                allConc = false;
                            }

                            if (elementSegregated.balance_now_conc) {

                                element.inProgressConc = true;
                                groupConciliaded = true;
                            }

                        }

                        //console.log("elementSegregated.balance_now_conc [" + elementSegregated.balance_now_id + "]: ", elementSegregated.balance_now_conc);

                    });

                    if (allConc && groupConciliaded) {
                        //if (allConc) {
                        element.balance_now_conc = true;
                    } else if (!allConc) {
                        element.balance_now_conc = false;
                    }
                }


                //console.log("element.balance_now_conc: ", element.balance_now_conc);

            });

            //Tem que reprocessar o concilio do asset pai
            console.log("ASSETS POS CONCILIO: ", newAssetsFormatted);

            setAssetsFormatted(newAssetsFormatted);
        }

    }

    const [segregation, setSegregation] = React.useState(null);
    const [segregationOnScreen, setSegregationOnScreen] = React.useState(null);

    const handleSegregation = (event, newSegregation) => {

        if (newSegregation != segregationOnScreen) {
            setSegregation(newSegregation);
        }

    };

    /**
     * Atualização em massa das pendências listadas no modal de análise.
     * @param {String} kind 'quotas' ou 'infos'
     */
    async function handleUpdateFundsPendencies(kind) {

        const month = clientOn.client.selectedMonth;
        const year = clientOn.client.selectedYear;

        const funds = kind === 'quotas' ?
            fundsPendencies.fundsNoQuotas : fundsPendencies.fundsNoInfos;

        if (!funds || !funds.length) return;

        setFundsPendenciesResult(null);
        setFundsPendenciesProgress({
            running: true,
            stage: kind === 'quotas' ? 'cotas' : 'dados cadastrais',
            current: 0,
            total: funds.length,
            label: '',
        });

        const doBulkUpdate = kind === 'quotas' ?
            doBulkUpdateQuotasByListFunds : doBulkUpdateInfosByListFunds;

        const result = await doBulkUpdate(funds, month, year,
            (progress) => setFundsPendenciesProgress({ running: true, ...progress }));

        setFundsPendenciesProgress({ running: false });
        setFundsPendenciesResult(result);

        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: result.failures.length ? 'warning' : 'success',
            message: result.failures.length ?
                result.updated.length + ' fundo(s) atualizado(s), ' + result.failures.length + ' com falha'
                : 'Informações atualizadas com sucesso!'
        }))

        if (result.updated.length) {

            setInnerLoad({ loadMessage: "Carregando informações..." })

            await loadInfosAssets(clientOn.client.id,
                month,
                year,
                segregation,
                true, clientOn.client.portfolio_init, isClientAbleToCurrentMonth);
        }

    }

    /**
     * Atualização em massa das cotas do MÊS ANTERIOR, disparada pelo aviso de lançamento
     * "Fundos sem informações de cotas mensais para o mês anterior".
     *
     * doBulkUpdateQuotasByListFunds deriva todo o período (inclusive a resolução de
     * ticker/sufixo/subclasse por vigência) do mês/ano recebidos, então basta passar o mês anterior
     * guardado no payload do modal.
     */
    async function handleUpdateQuotasBefore() {

        const { updatableFunds, period } = fundsToInconsistentFundsModal || {};

        if (!updatableFunds || !updatableFunds.length || !period) return;

        setInconsistentFundsResult(null);
        setInconsistentFundsProgress({
            running: true,
            stage: 'cotas',
            current: 0,
            total: updatableFunds.length,
            label: '',
        });

        const result = await doBulkUpdateQuotasByListFunds(updatableFunds, period.month, period.year,
            (progress) => setInconsistentFundsProgress({ running: true, ...progress }));

        setInconsistentFundsProgress({ running: false });
        setInconsistentFundsResult(result);

        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: result.failures.length ? 'warning' : 'success',
            message: result.failures.length ?
                result.updated.length + ' fundo(s) atualizado(s), ' + result.failures.length + ' com falha'
                : 'Cotas do mês anterior atualizadas com sucesso!'
        }))

        if (result.updated.length) {

            //Tirando do aviso os fundos que o servidor confirmou: sem isso o modal continuaria
            //listando os fundos já resolvidos e oferecendo o botão com a contagem antiga. A lista
            //recarregada de assetsFormatted não serve aqui — o payload do modal é um retrato
            //tirado dentro do launchWallet, e o `result` é a fonte exata do que foi gravado.
            const updatedFundsIds = new Set(result.updated);
            setFundsToInconsistentFundsModal(current => ({
                ...current,
                //Linhas de TÍTULO não têm fund_id e por isso permanecem, como deve ser
                funds: (current.funds || []).filter(el => !updatedFundsIds.has(el.fund_id)),
                updatableFunds: (current.updatableFunds || []).filter(el => !updatedFundsIds.has(el.fund_id)),
            }));

            setInnerLoad({ loadMessage: "Carregando informações..." })

            //Recarga do MÊS SELECIONADO: quotas_anbima_before vem do join do mês anterior feito
            //pela própria consulta do mês (fund.controller.getClientAllAssetsByDateAndRegime)
            await loadInfosAssets(clientOn.client.id,
                clientOn.client.selectedMonth,
                clientOn.client.selectedYear,
                segregation,
                true, clientOn.client.portfolio_init, isClientAbleToCurrentMonth);
        }

    }

    function s2ab(s) {
        var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;
    }

    function downloadBlob(blob, name = 'file.txt') {
        if (
            window.navigator &&
            window.navigator.msSaveOrOpenBlob
        ) return window.navigator.msSaveOrOpenBlob(blob);

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = data;
        link.download = name;

        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            })
        );

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
    }

    function generateValidationRentExcel(data) {

        const sheetName = "Validação";
        const columns = ['DATA', 'VALOR COTA CARTEIRA', 'RESULT_APP_RESG (R$)', 'ADD_COTAS', 'PL'];

        // dispatch(allActions.innerLoadActions.setInnerLoad({
        //     show: true,
        //     loadMessage: 'Gerando planilha...',
        // }));
        setInnerLoad({ loadMessage: "Gerando planilha..." })

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Validação de rentabilidades",
            Author: "UNO",
        }

        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push(columns)

        Object.entries(data).map(([date, el]) => {
            ws_data.push([date, el.quota_value, el.result_app_rescues, el.add_quotas, el.newPl]);
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), 'Validacao_Rentabilidades.xlsx');

        // dispatch(allActions.innerLoadActions.setInnerLoad({
        //     show: false,
        // }));
        setInnerLoad(null)

    }

    async function processPreInsertTransactions(transactions, invalidColumns, invalidDates, assets, accounts, clientOn) {
        const dataToInsert = await SystemValidationsController.doPreInsertsTransactions(transactions, invalidColumns, invalidDates, assets, accounts, clientOn, dispatch);
        setDataToInsert(dataToInsert);
        dispatch(allActions.fullLoadActions.setFullLoad({
            show: false,
            message: ""
        }))

        setShowImportModal(true);
    }

    const doDeleteTransactions = async (transactionsIds) => {

        setInnerLoad({
            loadMessage: `Excluindo movimentações selecionadas...`
        })

        for (let index = 0; index < transactionsIds.length; index++) {

            const response = await TransactionAPI.deleteTransaction(transactionsIds[index]);

        }

        loadInfosAssets(clientOn.client.id,
            clientOn.client.selectedMonth,
            clientOn.client.selectedYear,
            segregation,
            true, clientOn.client.portfolio_init, isClientAbleToCurrentMonth);

    }

    //A movimentação não pode ser alterada caso a carteira já tenha sido fechada
    function unableToChange() {

        if (!clientOn?.client) return true;
        return !isDateAfterClosedMonth(moment.utc(new Date(clientOn.client.selectedYear, parseInt(clientOn.client.selectedMonth) - 1, 1)).format("DD/MM/YYYY"),
            clientOn.client.portfolio_closed,
            false)
    }

    useEffect(() => {

        console.log("USE EFFECT COLETA")

        if (clientOn
            && clientOn.client &&
            (
                !clientOnScreen ||

                (
                    (clientOnScreen.id != clientOn.client.id)
                    ||
                    (
                        clientOnScreen.id == clientOn.client.id
                        &&
                        (
                            (
                                clientOnScreen.selectedMonth != clientOn.client.selectedMonth
                                ||
                                clientOnScreen.selectedYear != clientOn.client.selectedYear
                            )
                            ||
                            (rightContent && rightContent.action == 'update') //update
                            ||
                            (segregation != segregationOnScreen) //update
                        )
                    )
                )
            )
        ) {

            console.log("PASSOU SET YEARS")

            // dispatch(allActions.innerLoadActions.setInnerLoad({
            //     show: true,
            //     loadMessage: 'Carregando informações...',
            //     cod: codsInnerLoad.balancesCollectionScreen
            // }));
            setInnerLoad({ loadMessage: "Carregando informações" })

            setClientAccounts([])
            setTransactions(undefined)
            setAssetsFormatted(undefined);
            setQuotasModelDivergence(null);
            setSegregationOnScreen(segregation);

            setFullDiaryPl(undefined);
            setInitPortfolioQuota(undefined);
            setRentPortfolioInMonth(undefined);
            setCheckedJustToConciliations(false);
            setDataToInconsistentTitlesModal();
            setEnableDivergentTitles(false);

            if (clientOn.client.selectedMonth && clientOn.client.selectedYear) {

                setClientOnScreen(_.cloneDeep(clientOn.client));

                //getClientAccountsAndTransactions(clientOn.client.id, clientOn.client.selectedMonth, clientOn.client.selectedYear);            
                console.log("CHAMOU LOAD INFOS ASSETS: ", clientOn.client.id);
                console.log("MONTH: ", clientOn.client.selectedMonth);
                console.log("YEAR: ", clientOn.client.selectedYear);

                loadInfosAssets(clientOn.client.id,
                    clientOn.client.selectedMonth,
                    clientOn.client.selectedYear,
                    segregation,
                    true, clientOn.client.portfolio_init, isClientAbleToCurrentMonth);
                getDataToCreateTransaction();

                console.log("RIGHT CONTENT: ", rightContent);
                dispatch(allActions.rightContentActions.setRightContent(null))
            }


        } else if (rightContent
            && rightContent.action
            && rightContent.action.task == 'updateConcilio') {

            // rightContent.action = {
            //     task: 'updateConcilio',
            //     data: {
            //          balanceId: balanceId,                
            //     }
            // }

            console.log("RIGHT CONTENT: ", rightContent);
            updateConcilio(rightContent.action.data.balanceId);
            //dispatch(allActions.rightContentActions.setRightContent(null))

        }

        //Inicio import Excel
        if (file) {

            console.log("HANDLE FILE")
            if (clientOn && clientOn.client) {

                const responseValidFile = isFileForClientOn(file, clientOn.client, 'MOVS')
                if (responseValidFile.success) {

                    dispatch(allActions.fullLoadActions.setFullLoad({
                        show: true,
                        message: "Validando planilha..."
                    }))

                    handleFile();

                } else {

                    setDataToInsert({

                        client: clientOn.client,
                        currentFileName: file.name,
                        rightFileName: responseValidFile.rightName + '.xlsm',


                    });

                    setShowImportModal(true);
                }
            }

        }

        //if (data && data.length > 0 && !dataListFormatted && importYear) {
        if (data && data.length > 0 && !dataListFormatted) {

            console.log("DATA: ", data);

            let dataLFormatted = [];
            let invalidColumns = [];
            let invalidDates = [];
            for (let i = 0; i < data.length; i++) {

                //console.log("Convertendo: ", data[i]);

                //Verificando se há alguma coluna invalida
                if (i === 0) {
                    invalidColumns = verifyColumnsExcel(data[i]);
                    if (invalidColumns.length > 0) {
                        break;
                    }
                }

                if (data[i]['DATA'] != undefined && data[i]['DATA'] != null && data[i]['DATA'] != "") {
                    //console.log("data[i]['DATA']: ", data[i]['DATA']);
                    if (Number.isInteger(data[i]['DATA'])) {
                        data[i].dataFormatada = moment.utc(getJsDateFromExcel(data[i]['DATA'])).format('DD/MM/YYYY');

                        dataLFormatted.push(data[i]);
                    } else if (typeof data[i]['DATA'] === 'string'
                        && moment.utc(data[i]['DATA'].trim(), 'DD/MM/YYYY', true).isValid()) {
                        //Célula de data salva como texto na planilha (ex.: "04/12/2023")
                        data[i].dataFormatada = data[i]['DATA'].trim();

                        dataLFormatted.push(data[i]);
                    } else {

                        invalidDates.push(data[i]['DATA']);
                        console.log("INVALID DATES: ", invalidDates);
                        //data[i].dataFormatada = data[i]['DATA'];
                    }


                }
                //data[i].dataFormatada = moment.utc(getJsDateFromExcel(data[i].DataOperacao)).add(1, 'days').format('DD/MM/YYYY');
                //delete data[i]['DATA'],                

            }

            //console.log(dataMonthFormatted);
            console.log("MOVIMENTAÇÕES VÁLIDAS: ", dataLFormatted);

            setDataListFormatted({
                invalidDates: invalidDates,
                data: dataLFormatted,
                invalidColumns: invalidColumns
            });

        } else if (data && data.length == 0) {

            dispatch(allActions.fullLoadActions.setFullLoad({
                show: false,
                message: ""
            }))

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: "A planilha não possui dados"
            }))

        }

        if (dataListFormatted
            && clientOnScreen.id == clientOn.client.id) {

            //doInsertsTransactions(dataListFormatted);
            doPreInserts(dataListFormatted.data, dataListFormatted.invalidColumns, dataListFormatted.invalidDates);
            //processPreInsertTransactions(dataListFormatted.data, dataListFormatted.invalidColumns, dataListFormatted.invalidDates, clientAssets, clientAccounts, clientOn);

        }
        //Fim import excel

    }, [
        clientOn,
        file,
        dataListFormatted,
        rightContent,
        segregation
    ])

    const createTransactionDeps = useMemo(() => {
        return {
            accounts: clientAccounts,
            funds: clientFunds,
            titles: clientTitles,
            assets: clientAssets,
            titleAssets: clientTitleAssets,
            operations: clientOperations,
        }
    }, [clientAccounts,
        clientFunds,
        clientTitles,
        clientAssets,
        clientTitleAssets,
        clientOperations,])

    const goToCreateTransaction = () => {
        if (clientFunds && clientFunds.length > 0) {
            dispatch(allActions.rightContentActions.setRightContent({
                path: 'newTransaction',
                data: {
                    ...createTransactionDeps
                }
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'warning',
                message: 'Para criar uma movimentação você precisa primeiro criar um ATIVO',
            }))
        }
    }

    const checkParamsAbleToCollect = () => {
        return clientOn
            && clientOn.client
            && clientOn.client.selectedYear && clientOn.client.selectedMonth
            && isDateAfterClosedMonth(moment.utc(new Date(clientOn.client.selectedYear, parseInt(clientOn.client.selectedMonth) - 1, 1)).format("DD/MM/YYYY"),
                clientOn.client.portfolio_closed,
                false)
            && !isDateBeforeInit(getFirstDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear), clientOn.client.portfolio_init)
    }

    const checkIsAbleManagerAddTransaction = useMemo(() => {
        if (!currentUser || !clientOn) return false;
        return clientOn?.client?.is_able_transactions_current_month
            && checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor, roles.manager, roles.submanager])
            //&& (moment.utc(new Date()).format("M/YYYY") == (parseInt(clientOn.client.selectedMonth) + '/' + clientOn.client.selectedYear))
            && checkParamsAbleToCollect()
    }, [clientOn, currentUser])

    /**
     * @type {import('@material-ui/lab').SpeedDialActionProps[]}
     */
    const speedDialActions = [
        {
            htmlFor: 'file',
            key: 'import-fab',
            icon: <PublishIcon />,
            tooltipOpen: true,
            tooltipTitle: 'Importar movimentações',
            onClick: () => doClickinputFile()
        },
        {
            key: 'asset-create-fab',
            icon: <AddIcon />,
            tooltipOpen: true,
            tooltipTitle: 'Cadastrar ativo',
            onClick: () => doCreateAsset()
        },
        {
            key: 'asset-title-create-fab',
            icon: <AddIcon />,
            tooltipOpen: true,
            tooltipTitle: 'Cadastrar título',
            onClick: () => doCreateAssetTitle()
        },
        {
            key: 'transaction-create-fab',
            icon: <AddIcon />,
            tooltipOpen: true,
            tooltipTitle: 'Cadastrar movimentação',
            onClick: () => {
                goToCreateTransaction();
            }
        },
    ]

    //Só o aviso de cotas do mês anterior traz updatableFunds; mesmo gate de papel do botão
    //"Alerta", que dispara a outra atualização em massa de cotas
    const quotasBeforeToUpdate = fundsToInconsistentFundsModal
        && fundsToInconsistentFundsModal.updatableFunds
        && fundsToInconsistentFundsModal.updatableFunds.length
        && checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor]) ?
        fundsToInconsistentFundsModal.updatableFunds : null;

    return (
        <div className={classes.root}>

            <div className={classes.tabsWithRight}>
                <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>

                    <MyTabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>

                        <MyTab label="Coleta" />
                        <MyTab disabled={innerLoad && !innerLoad.emptyMessage} label={"Movimentações [ " + (transactions ? transactions.length : '-') + " ]"} />

                    </MyTabs>


                </div>

                {
                    tabValue == 1 && transactions && transactions.length ?
                        <MyAutoComplete
                            onChange={(event, newValue) => {
                                setFundInMovs(newValue);
                            }}
                            customWidth={'380px'}
                            options={allFundsInMovs}
                            autoComplete
                            label={'Nome do fundo ou CNPJ'}
                            filterOptions={(options, state) => {
                                if (!options) return [];
                                return options.filter(element => element.cnpj
                                    .includes(state.inputValue)
                                    || element.fund_name.toLowerCase().includes(state.inputValue.toLowerCase()));
                            }}
                            value={fundInMovs ? fundInMovs : null}
                            getOptionLabel={(option) => formatStringToDisplay(option.fund_name, 5, '...')}
                            renderOption={(option) => (
                                <React.Fragment key={'autocomplete-movs-balance-collection-' + option.id}>
                                    <span className={classes.bold}>{option.fund_name}</span>
                                </React.Fragment>
                            )}
                            renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                        /> : null
                }



                {
                    tabValue == 1 ?
                        <div style={{ marginLeft: "16px", display: "flex", alignItems: "flex-start", flexDirection: 'column' }}>
                            <div>
                                {transactions && transactions.length && totalAmountTransactionsApplications
                                    && (!innerLoad)
                                    ?
                                    <div style={{
                                        whiteSpace: 'nowrap',
                                        marginRight: '15px'
                                    }}>
                                        {'App: '}<span className={classes.green}>{applyMaskAmount(totalAmountTransactionsApplications, true)}</span>
                                    </div>
                                    : null
                                }
                            </div>
                            <div>
                                {transactions && transactions.length && totalAmountTransactionsRescues
                                    && (!innerLoad)
                                    ?
                                    <div style={{
                                        whiteSpace: 'nowrap',
                                        marginRight: '15px'
                                    }}>
                                        {'Res: '}<span className={classes.red}>{applyMaskAmount(totalAmountTransactionsRescues, true)}</span>
                                    </div>
                                    : null
                                }
                            </div>
                        </div> : null
                }

                {
                    tabValue == 1 ?//removendo diff movs
                        <div style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}>
                            <div>
                                {transactions && transactions.length && totalAmountTransactions
                                    && (!innerLoad)
                                    ?
                                    <div style={{
                                        whiteSpace: 'nowrap',
                                        marginRight: '15px'
                                    }}>
                                        {'Dif Movs: '}<span className={
                                            totalAmountTransactions < 0 ?
                                                classes.red : classes.green}>{applyMaskAmount(totalAmountTransactions, true)}</span>
                                    </div>
                                    : null
                                }
                            </div>
                        </div> : null
                }




                {
                    tabValue === 0 ?
                        <div className={classes.rightHeader}>

                            <div>
                                {
                                    rentPortfolioInMonth
                                        && (!innerLoad)
                                        && !segregation
                                        && (!isClientAbleToCurrentMonth || checkUserIsRole(currentUser, [roles.superadmin]))
                                        ?
                                        <div style={{
                                            whiteSpace: 'nowrap',
                                            marginRight: '15px'
                                        }}>
                                            {'Rent: '}<span className={
                                                rentPortfolioInMonthMoney < 0 ?
                                                    classes.red : classes.green}>{applyMaskAmount(rentPortfolioInMonthMoney)}</span><span className={
                                                        rentPortfolioInMonth < 0 ?
                                                            classes.red : classes.green}> ({applyMaskAmount(rentPortfolioInMonth, null) + "%"})</span>
                                        </div>
                                        : null
                                }
                            </div>

                            <MyToggleSegregationButton
                                marginRight
                                value={segregation}
                                handleValue={handleSegregation}
                                disabled={innerLoad && !innerLoad.emptyMessage}
                                clientOn={clientOn}
                            />

                            {
                                checkParamsAbleToCollect() ?
                                    <>
                                        {

                                            (
                                                //Verificar role
                                                checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor])

                                                &&

                                                (clientOn
                                                    && clientOn.client
                                                    && ((assetsFormatted && assetsFormatted.length > 0) || (offAssets && offAssets.length > 0))
                                                    && !invalidQuotas)
                                            ) ?

                                                <>
                                                    {
                                                        //Como agora alguns clientes possuem liberdade no mês vigente necessário adicionar essa
                                                        //condição para que não apareça o botão lançar no mês vigente para internos da LEMA
                                                        (moment.utc(new Date()).format("M/YYYY") != (parseInt(clientOn.client.selectedMonth) + '/' + clientOn.client.selectedYear)) ?
                                                            <UnoButton
                                                                size={'small'}
                                                                onClick={() => handleLaunchWalletWithConciliationCheck()}
                                                                type='success'
                                                                startIcon={<AccountBalanceWalletIcon />}>
                                                                {"Lançar"}
                                                            </UnoButton> : null
                                                    }
                                                </>
                                                :
                                                <>

                                                    {invalidQuotas ?
                                                        <UnoButton
                                                            size={'small'}
                                                            className={classes.spacingLeft1}
                                                            onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                                                path: 'invalidQuotas',
                                                                data: {
                                                                    month: clientOn.client.selectedMonth,
                                                                    year: clientOn.client.selectedYear,
                                                                    clientFunds: clientFunds,
                                                                    clientTitles: clientTitles,
                                                                    invalidQuotas: invalidQuotas,
                                                                }
                                                            }))}
                                                            type='error'>
                                                            {"Cotas inconsistentes"}
                                                        </UnoButton>
                                                        : null}
                                                </>

                                        }

                                    </>
                                    :
                                    <>

                                        {


                                            clientOn
                                                && clientOn.client
                                                && clientOn.client.selectedYear && clientOn.client.selectedMonth ?
                                                <>
                                                    {
                                                        isDateBeforeInit(getFirstDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear), clientOn.client.portfolio_init) ?
                                                            <Typography variant={'h6'} className={classes.lounchedWalletLabel}>
                                                                <span>{"Início da carteira: " + moment.utc(clientOn.client.portfolio_init).format('MM/YYYY')}</span>
                                                            </Typography>

                                                            :

                                                            <>
                                                                {/* {
                                                                    checkUserIsRole(currentUser, [roles.superadmin]) &&
                                                                    <UnoButton
                                                                        isIconButton
                                                                        onClick={() => generateValidationRentExcel(fullDiaryPl)}
                                                                        size='small'
                                                                        type='warning'
                                                                    />
                                                                } */}

                                                                <Typography variant={'h6'} className={classes.lounchedWalletLabel}>
                                                                    <span>{"Lançada "}</span><DoneIcon />
                                                                </Typography>
                                                            </>

                                                    }

                                                </> : null
                                        }

                                    </>


                            }

                            {
                                //Fica fora do bloco do botão "Lançar" de propósito: aquele bloco exige
                                //!invalidQuotas, e é justamente um fundo sem cotas que preenche
                                //invalidQuotas — o alerta desapareceria quando mais é necessário.
                                //!innerLoad evita mostrar um contador de assetsFormatted ainda em carga
                                fundsPendenciesCount > 0
                                    && !innerLoad
                                    && checkParamsAbleToCollect()
                                    && checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor]) ?
                                    <UnoButton
                                        size={'small'}
                                        className={classes.spacingLeft1}
                                        onClick={() => {
                                            setFundsPendenciesResult(null);
                                            setShowFundsPendenciesModal(true);
                                        }}
                                        type='warning'
                                        startIcon={<ReportProblemIcon />}>
                                        {"Alerta (" + fundsPendenciesCount + ")"}
                                    </UnoButton> : null
                            }

                            {
                                checkIsAbleManagerAddTransaction ?
                                    <UnoButton
                                        size={'small'}
                                        className={classes.spacingLeft1}
                                        onClick={() => goToCreateTransaction()}
                                        type='success'
                                        startIcon={<AddIcon />}>
                                        {"Cadastrar Movimentação"}
                                    </UnoButton> : null
                            }

                        </div>
                        : null
                }



            </div>

            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>

                {tabValue === 0 ?
                    <MyTable
                        initSizeTable={initSizeTable}
                        setCurrentSizeTable={setCurrentSizeTable}
                        stickyHeader
                        size="small"
                        onScroll={(value) => setAppearFab(value)}
                        selectable="true">
                        <colgroup>
                            <col width="35%" />
                            <col width="15%" />
                            <col width="15%" />
                            <col width="5%" />
                            <col width="15%" />
                            <col width="15%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell className={classes.tableTh} align="center"></TableCell> */}
                                <TableCell align="left">Ativo</TableCell>
                                <TableCell align="right">Saldo Anterior</TableCell>
                                {/* <TableCell className={classes.tableTh} align="right"></TableCell> */}
                                <TableCell align="right">Saldo Atual</TableCell>
                                {/* <TableCell className={classes.tableTh} align="right">Saldo Validado</TableCell> */}
                                <TableCell align="center" className='noPaddingCell'><Checkbox
                                    checked={checkedJustToConciliations}
                                    color="primary"
                                    onChange={handleChangeCheckBoxJustConciliations}
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                /></TableCell>
                                <TableCell align="left" className='noPaddingCell'>{checkedJustToConciliations ? 'A conciliar' : 'Todos'}</TableCell>
                                <TableCell align="right" onClick={() => changeReturnColumnType()}>Retorno {returnColumnType == 'money' ? '(R$)' : '(%)'}</TableCell>
                                {/* <TableCell className={classes.tableTh} align="right">Conciliação</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {assetsFormatted && checkedJustToConciliations ?
                                assetsFormatted?.filter(el => checkedJustToConciliations ? (el.needConciliation || el.needCheckRent || el.expiredWithoutRescue) : true).map((row, index) => (

                                    <Row key={'asset-transactions-' + index} row={row} offAsset={false} index={index} />

                                ))

                                :

                                assetsFormatted?.filter((_, index) => index < currentSizeTable).map((row, index) => (

                                    <Row key={'asset-transactions-' + index} row={row} offAsset={false} index={index} />

                                ))

                            }

                        </TableBody>
                        {
                            assetsFormatted && assetsFormatted.length > 0 ?
                                <TableFooter className={classes.myTableFooter}>
                                    <TableRow className='totalLineInvestiments' key={'footer-t-assets-collect-investiments'}>
                                        <TableCell align="left">TOTAL INVESTIMENTOS</TableCell>
                                        <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(totalBeforeAmount, true)}</span></TableCell>
                                        <TableCell align="right"><span className={'spanTotal'}>{totalResultAmount ? applyMaskAmount(totalResultAmount, true) : "-"}</span></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                    <TableRow className='disponibilityLine' key={'footer-t-assets-collect-disponibility'}>
                                        <TableCell align="left">DISPONIBILIDADE</TableCell>
                                        <TableCell align="right"><span className={'spanTotal'}>{totalDisponibilityInAccounts.before ? applyMaskAmount(totalDisponibilityInAccounts.before, true) : "-"}</span></TableCell>
                                        <TableCell align="right"><span className={'spanTotal'}>{totalDisponibilityInAccounts.now ? applyMaskAmount(totalDisponibilityInAccounts.now, true) : "-"}</span></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                    <TableRow className='totalLinePL' key={'footer-t-assets-collect-total'}>
                                        <TableCell align="left">TOTAL PATRIMÔNIO</TableCell>
                                        <TableCell align="right"><span className={'spanTotal'}>{totalBeforeAmount != null && totalDisponibilityInAccounts.before != null ?
                                            applyMaskAmount(totalBeforeAmount + totalDisponibilityInAccounts.before, true) : '-'}</span></TableCell>
                                        <TableCell align="right"><span className={'spanTotal'}>{totalResultAmount != null && totalDisponibilityInAccounts.now != null ?
                                            applyMaskAmount(totalResultAmount + totalDisponibilityInAccounts.now, true) : '-'}</span></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableFooter> : null
                        }

                    </MyTable>

                    :

                    <TransactionsTable
                        unableToChange={unableToChange()}
                        doDeleteTransactions={(transactionsIds) => doDeleteTransactions(transactionsIds)}
                        transactions={transactions?.filter(el => !fundInMovs || (fundInMovs != null && el.fund_id == fundInMovs.id))}
                        clientAccounts={clientAccounts}
                        clientFunds={clientFunds}
                        clientTitles={clientTitles}
                        clientAssets={clientAssets}
                        clientTitleAssets={clientTitleAssets}
                        clientOperations={clientOperations}
                    />
                }
            </DefaultScrollWithHeaderContent>

            <Backdrop
                onClick={handleCloseFab}
                style={{ zIndex: '999' }}
                open={openFab} />

            {

                clientOn && clientOn.client &&

                    //Verificar role
                    checkUserIsRole(currentUser,
                        [roles.admin,
                        roles.superadmin,
                        roles.advisor])
                    ?

                    <Fade
                        in={appearFab}
                        timeout={transitionDuration}
                        unmountOnExit>
                        <div className={speedDialClasses.speedDial}>
                            <SpeedDial
                                ariaLabel="Coleta de saldos"
                                onClick={() => handleOpenFab(!openFab)}
                                //hidden={true}
                                hidden={hidden}
                                icon={<SpeedDialIcon />}
                                open={openFab}
                                direction={direction}>
                                {speedDialActions.map((props) => (<SpeedDialAction {...props} />))}
                            </SpeedDial>

                        </div>
                    </Fade> : null

            }

            <div>
                <input
                    ref={inputFile}
                    className={classes.input}
                    id="file"
                    multiple
                    accept={SheetJSFT}
                    type="file"
                    onClick={() => resetImportVariables()}
                    onChange={handleChangeFile}
                />
            </div>

            <Dialog open={showSelicCdiIpcaModal} maxWidth="xs" fullWidth>
                <DialogTitle>Índices do mês vigente</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2" style={{ marginBottom: 16 }}>
                        Para calcular a rentabilidade do mês vigente, informe os índices mensais:
                    </Typography>
                    <MyTextField
                        outerlabel="CDI % ao mês"
                        fullWidth
                        mask={["currency"]}
                        style={{ marginBottom: 12 }}
                        value={selicCdiIpcaForm.cdi}
                        onChange={v => setSelicCdiIpcaForm(f => ({ ...f, cdi: v }))}
                    />
                    <MyTextField
                        outerlabel="IPCA % ao mês"
                        fullWidth
                        mask={["currency"]}
                        style={{ marginBottom: 12 }}
                        value={selicCdiIpcaForm.ipca}
                        onChange={v => setSelicCdiIpcaForm(f => ({ ...f, ipca: v }))}
                    />
                    <MyTextField
                        outerlabel="SELIC % ao mês"
                        fullWidth
                        mask={["currency"]}
                        value={selicCdiIpcaForm.selic}
                        onChange={v => setSelicCdiIpcaForm(f => ({ ...f, selic: v }))}
                    />
                </DialogContent>
                <DialogActions>
                    <UnoButton
                        onClick={saveSelicCdiIpca}
                        loading={selicCdiIpcaSaving}
                        disabled={!selicCdiIpcaForm.cdi || !selicCdiIpcaForm.ipca || !selicCdiIpcaForm.selic || selicCdiIpcaSaving}
                        type="primary">
                        Salvar
                    </UnoButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={showSelicCdiIpcaWarning}
                onClose={() => setShowSelicCdiIpcaWarning(false)}
                maxWidth="xs"
                fullWidth>
                <DialogTitle>Índices do mês vigente não cadastrados</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        Os índices de CDI, IPCA e SELIC para o mês vigente ainda não foram cadastrados.
                        As rentabilidades projetadas dos títulos não serão exibidas.
                        Entre em contato com o administrador para realizar o cadastro.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <UnoButton
                        onClick={() => setShowSelicCdiIpcaWarning(false)}
                        type="primary">
                        Entendido
                    </UnoButton>
                </DialogActions>
            </Dialog>

            <FundsPendenciesModal
                analysis={fundsPendencies}
                period={{
                    month: clientOn?.client?.selectedMonth,
                    year: clientOn?.client?.selectedYear
                }}
                progress={fundsPendenciesProgress}
                result={fundsPendenciesResult}
                onUpdateQuotas={() => handleUpdateFundsPendencies('quotas')}
                onUpdateInfos={() => handleUpdateFundsPendencies('infos')}
                closeModal={() => setShowFundsPendenciesModal(false)}
                open={showFundsPendenciesModal} />

            <InconsistentFundsModal
                fundsToInconsistentFundsModal={fundsToInconsistentFundsModal}
                actionLabel={quotasBeforeToUpdate ?
                    'Atualizar cotas (' + quotasBeforeToUpdate.length + ')' : undefined}
                onAction={quotasBeforeToUpdate ? handleUpdateQuotasBefore : undefined}
                progress={inconsistentFundsProgress}
                result={inconsistentFundsResult}
                closeModal={() => setShowInconsistentFundsModal(false)}
                open={showInconsistentFundsModal} />

            <InconsistentBalancesModal
                inconsistentBalancesValidations={inconsistentBalancesValidations}
                closeModal={() => setShowInconsistentBalancesValidationsModal(false)}
                open={showInconsistentBalancesValidationsModal} />

            <InconsistentTitlesModal
                data={dataToInconsistentTitlesModal ? dataToInconsistentTitlesModal : {}}
                handleAction={(action) => handleActionDivergentTitles(action)}
                open={dataToInconsistentTitlesModal ? true : false} />

            <DataImportModal
                dataToInsert={dataToInsert}
                handleModalImport={(doImport) => handleModalImport(doImport)}
                open={showImportModal} />

            <OffAssetsValidateModal
                dataOffAssets={dataOffAssets}
                handleModalOffAssets={(doAction) => handleModalOffAssets(doAction)}
                open={showOffAssetsValidateModal} />

            <AmortizationsToCreateModal
                data={amortizationsToCreate}
                open={showAmortizationToCreateModal}
                handleModal={(action) => handleAmortizationToCreateModal(action)} />

            <Dialog
                open={showConciliationModal}
                onClose={() => !conciliationLoading && setShowConciliationModal(false)}
                maxWidth="md"
                fullWidth>
                <DialogTitle>
                    {'Conciliações pendentes'}
                </DialogTitle>
                <DialogContent dividers style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {!assetsFormatted ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '32px' }}>
                            <CircularProgress size={32} />
                        </div>
                    ) : (() => {
                        const items = getConciliationItems().sort((a, b) => {
                            const aExceeds = itemExceedsLimit(a);
                            const bExceeds = itemExceedsLimit(b);
                            if (aExceeds && !bExceeds) return -1;
                            if (!aExceeds && bExceeds) return 1;
                            return 0;
                        });
                        const allCanConciliate = !items.some(item => itemExceedsLimit(item));
                        return (
                            <>
                                {!allCanConciliate && (
                                    <Typography variant="body2" style={{ color: 'red', marginBottom: '16px' }}>
                                        Alguns itens possuem divergências além do limite permitido e precisam ser conciliados manualmente antes de lançar.
                                    </Typography>
                                )}
                                {items.map((item, idx) => (
                                    <div key={'conc-item-' + idx}>
                                        <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '6px' }}>
                                            {renderAssetNameForModal(item.parentRow)}
                                        </Typography>
                                        {item.needsSpecialQuota && (
                                            <div style={{ marginBottom: '8px' }}>
                                                {getAlertSpecialClientQuotaContent(item.parentRow, () => setSpecialQuotaModalRow(item.parentRow), currentUser?.user?.role)}
                                            </div>
                                        )}
                                        {item.subRows.map((subRow, sIdx) => (
                                            <div key={'conc-sub-' + sIdx} style={{ marginBottom: '8px' }}>
                                                {getAlertBalanceContent(subRow, null, currentUser?.user?.role)}
                                            </div>
                                        ))}
                                        {idx < items.length - 1 && <Divider style={{ margin: '12px 0' }} />}
                                    </div>
                                ))}
                            </>
                        );
                    })()}
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <UnoButton
                        onClick={() => setShowConciliationModal(false)}
                        disabled={conciliationLoading || !assetsFormatted}
                        type='errorClean'>
                        Cancelar
                    </UnoButton>
                    <UnoButton
                        onClick={handleConciliateAllAndLaunch}
                        disabled={conciliationLoading || !assetsFormatted || getConciliationItems().some(item => itemExceedsLimit(item)) || !getConciliationItems().every(item => item.subRows.every(subRow => canConciliateRow(subRow)))}
                        type='success'
                        startIcon={(conciliationLoading || !assetsFormatted) ? <CircularProgress size={16} /> : <AccountBalanceWalletIcon />}>
                        Conciliar tudo e lançar
                    </UnoButton>
                </DialogActions>
            </Dialog>

            <NewSpecialClientQuotaModal
                open={!!specialQuotaModalRow}
                asset={specialQuotaModalRow}
                lastDayQuotaInMonth={null}
                month={clientOn?.client?.selectedMonth}
                year={clientOn?.client?.selectedYear}
                handleAction={() => setSpecialQuotaModalRow(null)} />

        </div >
    );
}



